import { AfterViewInit, Component, Input, OnDestroy, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { FadeInTop } from "../../../shared/animations/fade-in-top.decorator";
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from "../../../shared/haspermission/hasPermission.service";
import { NotificationService } from "../../../shared/utils/notification.service";
import { ShaService } from "../../../shared/jssha/jssha.service";
import {
    ByProfile,
    Childrens,
    ExtraInfo,
    FindByGroupsAdvanceSearch2,
    GroupsChildren,
    ImageProfile,
    Principals,
    TypeTicket,
    User,
    UsersGestionByProfile,
    UsersService,
    UserView,
    Zonas
} from "../users.service";
import { Groups, GroupsService } from "../../+groups/group.service";
import { Profile, ProfilesService } from "../../+profiles/profiles.service";
import { I18nPipe } from "../../../shared/i18n/i18n.pipe";
import { isNullOrUndefined } from "util";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TurnosLaborales, TurnosService } from "../../../+turnosLaborales/turnos.service";
import { FormBuilder, FormGroup, NgForm, ValidationErrors, Validators } from "@angular/forms";
import { DuallistboxOption } from "../../../shared/forms/input/original-duallistbox.component";
import { BsModalRef } from 'ngx-bootstrap';
import { Geocerca, GeocercasService } from '../../../+geocercas/geocercas.service';
import { TicketAdvanceSearch } from '../../../+tickets/ticket.service';
import { NzNotificationService } from 'ng-zorro-antd';
import { PageImpl } from 'app/common/http/PageImpl';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../../+login/auth.service';
import { ListaErrorsForms } from 'app/+admin/+sla/sla.service';
import { TicketTypeRequestView, TipoTicketService } from 'app/+admin/+configuraciones/+tickets/+tipos-ticket/tipos.service';
import { DevicesService,UserInfoDevice } from 'app/devices/devices.service';
import { KeyValueLegend } from 'app/+tickets/details/ticket-details.component';
import { PERFILES_ASIGNABLES_USERS_ACTIONS, PROFILE_IDS_ASIGNABLES_USERS_ACTIONS } from './users-actions-profiles.util';

@FadeInTop()
@Component({
    selector: 'sa-users-actions',
    templateUrl: 'users-actions.component.html',
    styleUrls: ['../users.style.css']
})
export class UsersActionsComponent implements OnInit, OnDestroy, AfterViewInit {
    tabs: { title: string, active: boolean }[] = [
        {
            title: 'GENERAL',
            active: true,
        },
        {
            title: 'GRUPOS',
            active: false
        },
        {
            title: 'USUARIOS',
            active: false
        },
        {
            title: 'GEOCERCAS',
            active: false
        }
    ];
    noValidateEmployeeNumber:any;
    havePremisionEditPermsisions: boolean = false;
    showValidateSecurityKey:boolean = false;
    pageTitle: string;
    readonly: boolean = false;
    forcePasswordAndStatusManagmenet: boolean = false;
    viewProfile: boolean;
    private id: number;
    private action: string;
    canUpdateByProfile: boolean = true;
    public model = {
        name: '',
        userName: '',
        realUserName: '',
        email: {
            value: '',
            valid: false
        },
        numTel:null,
        extra1: '',
        extra2: '',
        extra4: false,
        extra5: false,
        profile: 0,
        previousProfile: 0,
        permissionsList: [],
        profileTree: [],
        groups: [],
        users: [],
        password: null,
        passwordConfirm: null,
        extraInfo: {
            key: '',
            value: '',
            error: false
        },
        status: true,
        userGeofenceViewList: [],
        userGeofenceAlertViewList: [],
        viewInScheduleViewList: [],
        imageProfile: new ImageProfile(),
        extraConfiguration: {
            iam: [],
            dum: {
                ne: null
            },
            att: null,
            nvm: null,
            tmad: 30,
            e2e: true,
            bulk: false,
            priorizar:false,
            pagos: false,
            quiosco: null,
            idquiosco: null,
            validarEquipo: null,
            mdm: null,
            metrospre: 500,
            device: null,
            externa: null,
            cuadlog: null,
            autoasgeoale: null,
            vtw: false,
            agendex: null,
            tmm: 60,
            ntm: false,
            dashProd: false,
            editarPerfil: false
        },
        user_dimme: true
    };
    private hasPermissionSelected: boolean = false;
    private extraInfo = [];
    listOfProfiles: Array<Profile> = [];
    private listOfGroups: Array<Groups> = [];
    private gruposFiltro: number = null;
    private typeFiltro: string = 'operaciones';
    private duallistGroupsList: Array<DuallistboxOption> = [];
    private duallistUserList: Array<DuallistboxOption> = [];
    private tamDualis: number = 0;
    formSubmitted = false;
    workShifts: Array<TurnosLaborales> = [];
    private usersGeofenceList: any = [];
    private usersGeofenceAlertList: any = [];
    private idWorkShift: number = 0;
    private imageCrop: boolean = false;
    public imageProfile: any = null;
    public byprofile: ByProfile = new ByProfile();
    public byUser: ByProfile = new ByProfile();
    public underProfileList: Array<DuallistboxOption> = [];
    public availableItems: { id: string, name: string, val: string }[] = [];
    public availableItemsAlert: { id: string, name: string, val: string }[] = [];
    public geofencesArray: Array<Geocerca> = [];
    public geofencesAlertArray: Array<Geocerca> = [];
    private searchAdvance: TicketAdvanceSearch = new TicketAdvanceSearch();
    private idProfileLogged: number;

    private chatControl: chatContainerCtrl = new chatContainerCtrl();

    public confirm1: string;
    public confirmContent1: string;
    public confirmContent2: string;
    public error1: string;
    public errorContent1: string;
    public error2: string;
    public errorContent2: string;
    public errorContent3: string;
    public errorContent4: string;
    public errorContent5: string;
    public errorContent6: string;
    public errorContent7: string;
    public errorContent8: string;
    name = 'Angular';
    private selectedItems: any[] = [];
    private selectedItemsAlert: any[] = [];
    private currentSelectItems: any[] = [];
    private currentSelectItemsAlert: any[] = [];

    public bandExpRegCuadrilla: any = '';
    public Botonbloqueado: boolean = false;
    public subgruposUsuarios: boolean = false;
    public subgruposTipos: boolean = false;
    public showValidateDevice: boolean = false;

    public listOfSubGroups = [];
    public listOfTypes = [
        {
            typeId: 'operaciones',
            typeName: 'Operaciones'
        },
        {
            typeId: 'mantenimiento',
            typeName: 'Mantenimiento'
        },
        {
            typeId: 'recuperadoresC',
            typeName: 'Recuperadores Clientes'
        },
        {
            typeId: 'recuperadoresE',
            typeName: 'Recuperadores Equipos'
        },
        {
            typeId: 'construccion',
            typeName: 'Construccion'
        },
        {
            typeId: 'operaciones migracion',
            typeName: 'Operaciones migración'
        }
    ];
    public cargarFiltroSubgrupos: boolean = false;
    public primerDatoArray;
    public listOfTypes2 = [];
    public listTipoTecnologia = [];
    public isOperations: boolean = false;

    public UsersPageUsers: any;
    public selectAsignar: string;
    public bloqueado: boolean = false;

    public usersFind: FindByGroupsAdvanceSearch2 = new FindByGroupsAdvanceSearch2();
    public idGroupUser: number;
    private usersPage2: PageImpl<User> = new PageImpl<User>();

    private subscriptions: Subscription = new Subscription();
    public idLogget: number;
    public arrayCopiaGroups = [];
    public nohaySeleccionados: boolean = false;
    public visible: boolean = false;
    public loading = false;
    public newMaxScroll = 0;

    private onClose: Subject<boolean> = new Subject();
    public groupsTree: any = [];
    gruposObject = [];

    public FormValidacion: FormGroup;
    Errors: ListaErrorsForms[] = [];
    public passwordsIguales: boolean = false;
    public passwordRequerido: boolean = false;
    public extraConfiguracion = null;
    public tipoTecnologia:any = "Todos";
    viewPermission: boolean = false;

    public loader: boolean = false;

    private infoUserLogged: UserView = new UserView;
    public listOfQuioscos = [];

    private e2e: boolean = false;
    private showe2e: boolean = false;

    showPassword1 = false;
    showPassword2 = false;
    ojo1 = 'password'
    ojo2 = 'password';
    infoUSer: UserInfoDevice = new UserInfoDevice;
    infoUserError: boolean = false;
    btnUserinfo: boolean = false;
    showuuid: boolean = false;
    showbtnDelete: boolean = false;
    hideGeneralInfo: boolean = false;
    hideGroups: boolean = false;
    hideGeo: boolean = false;
    hideUSers: boolean = false;
    listOfProfilescopie = [];
    public disablePerfil: boolean = false;
    typeTicket = TypeTicket;
    userDimmeValidado: boolean = false;
    validandoEmpleado: boolean = false;
    disabledMailAndPhone: boolean = false;
    isSpecialProfileManagement: boolean = false;
    fromHeader: boolean = false;

    constructor(private route: ActivatedRoute,
                private authorization: AuthService,
                private domSn: DomSanitizer,
                private notifications: NotificationService,
                private shaService: ShaService,
                private service: UsersService,
                private profileService: ProfilesService,
                private turnosService: TurnosService,
                private groupService: GroupsService,
                private hasPermissionService: HasPermissionService,
                private geofencesService: GeocercasService,
                private i18n: I18nPipe,
                private notification: NzNotificationService,
                public bsModalRef: BsModalRef,
                public userService: UsersService,
                private formBuilder: FormBuilder,
                private ticketTypeService: TipoTicketService,
                private deviceService: DevicesService,
                private cdr: ChangeDetectorRef) {
        i18n.i18nService.subscribe(() => this.setTranslations(), null);
        this.listTipoTecnologia = ['Todos', 'Coaxial', 'Fibra'];

    }

    /*Funcion para activar el Tipo de Tecnologia*/
    removeAllAdministrators() {
        if (this.hasPermissionService.canAccess('ADD_ADMINISTRATORS')) {
            this.listOfProfiles = this.listOfProfilescopie.filter((item) => item.idTypeTicket == Number(this.extraConfiguracion))
        } else {
            this.listOfProfiles = this.listOfProfilescopie.filter((item) =>
                item.idTypeTicket == Number(this.extraConfiguracion) && !item.profileName.toLowerCase().includes('administrador'))
        }
    }
    onSelectChange(){
        this.removeAllAdministrators();

      // console.log(this.FormValidacion.controls.AutoAssigne.value);
      if(this.FormValidacion.controls.Tipo.value == 5){
        // this.model.extraConfiguration.e2e = true;
          this.showe2e = true;
      }else{
          this.showe2e = false;
        // this.FormValidacion.controls.e2e.reset(0);
        this.FormValidacion.controls.pagos.reset(0);
        this.FormValidacion.controls.quiosco.reset(0);
        this.FormValidacion.controls.validarEquipo.reset(0);
        // this.FormValidacion.controls.mdm.reset(0);

      }

      
      if(this.FormValidacion.controls.Tipo.value == 3 && this.FormValidacion.controls.AutoAssigne.value == true){
        this.isOperations = true;
        this.tipoTecnologia = "Todos";       
      // console.log(this.FormValidacion.controls.att.value);
      }else{
        this.isOperations = false;
        this.FormValidacion.controls.att.reset(0);
      }
    }

    setTranslations() {
        this.confirm1 = this.i18n.transform("Operation complete");
        this.confirmContent1 = this.i18n.transform("User information has been save");
        this.confirmContent2 = this.i18n.transform("User information has been update");
        this.error1 = this.i18n.transform("Error saving");
        this.errorContent1 = this.i18n.transform("Cannot save user");
        this.error2 = this.i18n.transform("Error updating");
        this.errorContent2 = this.i18n.transform("Cannot user profile");
        this.errorContent3 = this.i18n.transform("Cannot load permissions tree");
        this.errorContent4 = this.i18n.transform("Error to load user");
        this.errorContent5 = this.i18n.transform("Error to load profiles");
        this.errorContent6 = this.i18n.transform("Cannot load profiles list");
        this.errorContent7 = this.i18n.transform("Error to load groups");
        this.errorContent8 = this.i18n.transform("Cannot load groups list");
    }

    getUsersBysProfileSelected(profile) {
        console.log('profiles', profile)
        if (!isNullOrUndefined(profile))
            this.byprofile.idProfile = profile.target.value;
        if (this.model.profile == 134 || this.model.profile == 27 || this.model.profile == 94 || this.model.profile == 30 || this.model.profile == 63 || this.model.profile == 64 || this.model.profile == 88 || this.model.profile == 92 || this.model.profile == 130 || this.model.profile == 103 || this.model.profile == 175) {
            this.tabs = [
                {
                    title: 'GENERAL',
                    active: true,
                },
                {
                    title: 'GRUPOS',
                    active: false
                },
                {
                    title: 'GEOCERCAS',
                    active: false
                }
            ];
            $('#usuariosTab2').addClass('hideElement');

            // this.FormValidacion =
            // this.formBuilder.group({
            //     username: [this.model.userName,[Validators.required]],
            //     password: [this.model.password,[ Validators.minLength(6)]],//Validators.required,
            //     passwordConfirm: [this.model.passwordConfirm,[Validators.minLength(6)]],//Validators.required,
            //     name: [this.model.name,[Validators.required]],
            //     email: [this.model.email.value,[Validators.required, Validators.email]],
            //     userProfile: [this.model.profile,[Validators.required]],
            //     turnoLaboral: [this.idWorkShift,[Validators.required]],
            //     Sucursal: [this.model.extra1,[Validators.required]],
            //     Cuadrilla: [this.model.extra2,[Validators.required,Validators.pattern("^[a-zA-Z]+\-+([0-9])*$")]],
            //     noVendedor: [this.model.extra2],
            //     Tipo: [this.extraConfiguracion,[Validators.required]],
            //     AutoAssigne: [this.model.extra4],
            //     Estatus: [this.model.status],
            //     AutoAgendado: [this.model.extra5],
            //     Dum:[this.model.extraConfiguration.dum.ne],
            // });
        } else {
            this.tabs = [
                {
                    title: 'GENERAL',
                    active: true,
                },
                {
                    title: 'GRUPOS',
                    active: false
                },
                {
                    title: 'USUARIOS',
                    active: false
                },
                {
                    title: 'GEOCERCAS',
                    active: false
                },

            ];
            $('#usuariosTab2').removeClass('hideElement');



            // this.FormValidacion =
            // this.formBuilder.group({
            //     username: [this.model.userName,[Validators.required]],
            //     password: [this.model.password,[ Validators.minLength(6)]],//Validators.required,
            //     passwordConfirm: [this.model.passwordConfirm,[ Validators.minLength(6)]],//Validators.required,
            //     name: [this.model.name,[Validators.required]],
            //     email: [this.model.email.value,[Validators.required, Validators.email]],
            //     userProfile: [this.model.profile,[Validators.required]],
            //     turnoLaboral: [this.idWorkShift,[Validators.required]],
            //     Sucursal: [this.model.extra1],
            //     Cuadrilla: [this.model.extra2,[Validators.pattern("^[a-zA-Z]+\-+([0-9])*$")]],
            //     noVendedor: [this.model.extra2],
            //     Tipo: [this.extraConfiguracion],
            //     AutoAssigne: [this.model.extra4],
            //     Estatus: [this.model.status],
            //     AutoAgendado: [this.model.extra5],
            //     Dum:[this.model.extraConfiguration.dum.ne]
            // });
        }

        if (this.hasPermissionService.canAccess('UPDATE_USER_PERMISSION')){
            this.viewPermission = true;
            this.tabs.push({
                title: 'PERMISOS',
                active: false
            });
        }

        // if (!this.hasPermissionService.canAccess('UPDATE_GENERAL_INFO')){
        //     this.tabs.splice(0,1)
        // }else{
        //     this.listOfProfiles = this.listOfProfilescopie.filter((item) => item.idTypeTicket == Number(this.extraConfiguracion))
        //     this.hideGeneralInfo = false
        // }
        // if (!this.hasPermissionService.canAccess('UPDATE_GROUPS')){
        //     this.tabs.splice(1,1)
        // }else{
        //     this.hideGroups= false
        // }
        // if (!this.hasPermissionService.canAccess('UPDATE_GEOCERCA')){
        //     this.tabs.splice(2,1)
        // }else{
        //     this.hideGeo = false
        // }

        // if(this.model.profile == 34){
        //     this.FormValidacion =
        //         this.formBuilder.group({
        //             username: [this.model.userName, [Validators.required]],
        //             password: [this.model.password, [ Validators.minLength(6)]],//Validators.required,
        //             passwordConfirm: [this.model.passwordConfirm,[Validators.minLength(6)]],//Validators.required,
        //             name: [this.model.name, [Validators.required]],
        //             email: [this.model.email.value, [Validators.required, Validators.email]],
        //             userProfile: [this.model.profile, [Validators.required]],
        //             turnoLaboral: [this.idWorkShift, [Validators.required]],
        //             Sucursal: [this.model.extra1, [Validators.required]],
        //             Cuadrilla: [this.model.extra2],
        //             noVendedor: [this.model.extra2, [Validators.required, Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
        //             Tipo: [this.extraConfiguracion, [Validators.required]],
        //             AutoAssigne: [this.model.extra4],
        //             Estatus: [this.model.status],
        //             AutoAgendado: [this.model.extra5],
        //             Dum:[this.model.extraConfiguration.dum.ne],
        //         });
        // }
        this.crearFormVAlido();
    }

    changeGroups(data) {
        if (data instanceof Array) {
            this.model.groups = data.filter(group => group.selected).map(group => group.key);
            this.byprofile.idGroups = this.model.groups.map(group => +group);
        } else {
            this.model.groups = data;
            this.byprofile.idGroups.push(+data);
        }

        /**obteniendo lista de usuarios*/
        // this.duallistUserList = [];
        //comentado Otniel 2 septiembre
        // if (this.byprofile.idGroups[0] != null) {
        //     this.service.findByGroups(this.byprofile.idGroups[0]).subscribe(users1 => {
        //         /** filtrar a los usuarios y solo mostrar agentes**/
        //         let tmp = [];
        //         tmp = users1;
        //         users1 = [];
        //         tmp.forEach((element) => {
        //             if (element.profileName == "Agente"){
        //                 users1.push(element);
        //             }
        //         });
        //         /** filtrar a los usuarios y solo mostrar agentes**/
        //     //---------------------ordenamiento por name------------------------------------
        //     users1.sort((o1,o2)=>Intl.Collator().compare(o1.username.toLowerCase(),o2.username.toLowerCase()));
        //     //---------------------ordenamiento por name------------------------------------
        //         this.duallistUserList = users1.map(users => new DuallistboxOption(users.idUserApp.toString(), users.username, this.model.users.indexOf(users.idUserApp.toString()) > -1));
        //     });
        // }
        // comentado Otniel 2 septiembre

        // if(this.byprofile.idGroups.length == 1 || this.primerDatoArray != this.byprofile.idGroups[0])
        // this.getSubgroups(this.byprofile.idGroups);
    }

    getSubgroups(idGroups: number[], cargarFiltroSubgrupos?: boolean) {
        this.loader = true;
        this.listOfSubGroups = [];
        this.duallistUserList = [];
        this.visible = false;

        let arrayTemp = [];
        let arrayTempSubgrupos = [];
        this.subgruposUsuarios = false;
        this.gruposFiltro = null;
        this.subgruposTipos = false;

        if (idGroups.length != 0) {
            this.primerDatoArray = idGroups[0];

            this.groupService.getAllGroups(idGroups).subscribe((elementos) => {
                    elementos.sort((o1, o2) => Intl.Collator().compare(o1.groupName.toLowerCase(), o2.groupName.toLowerCase()));
                    arrayTempSubgrupos = elementos;
                }, (error) => {
                    this.loader = false;
                }
                , () => {
                    this.subgruposUsuarios = true;
                    if (arrayTempSubgrupos.length == 0) {
                        let gruopFind = this.listOfGroups.find((element) => element.groupId == idGroups[0]);
                        arrayTemp.push({
                            groupId: gruopFind.groupId,
                            groupName: gruopFind.groupName
                        });
                        // // filtro quitar Grupos que contengan la palabra grupos
                        let expReg = /grupo\s?/i;
                        let tmpExp = [];
                        arrayTemp.forEach((elemento) => {
                            if (elemento.groupName.toLowerCase().match(expReg)) {
                            } else {
                                tmpExp.push(elemento);
                            }
                        });
                        setTimeout(() => {
                            this.listOfSubGroups = tmpExp;
                            this.loader = false;
                        }, 1000);

                        // filtro quitar Grupos que contengan la palabra grupos
                        if (cargarFiltroSubgrupos == true) {
                            let filtroFind = this.listOfSubGroups.find((element) => element.groupId == this.model.groups[0]);
                            if (filtroFind != undefined) {
                                this.getTipos();
                                this.cargarFiltroSubgrupos = false;
                            }
                        }

                        //se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
                        if (this.arrayCopiaGroups.length != 0) {
                            this.arrayCopiaGroups.forEach((elementos) => {
                                let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                                let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                                if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                                    if (elementos.selected == true || elementos.selected == false) {
                                        this.duallistUserList.push(elementos);
                                    }
                                }
                            });

                            if (this.duallistGroupsList.length != 0) {
                                this.visible = true;
                            }
                        }
                        // se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
                    } else {
                        // filtro quitar Grupos que contengan la palabra grupos
                        let expReg = /grupo\s?/i;
                        let tmpExp = [];
                        arrayTempSubgrupos.forEach((elemento) => {
                            if (elemento.groupName.toLowerCase().match(expReg)) {
                            } else {
                                tmpExp.push(elemento);
                            }
                        });
                        setTimeout(() => {
                            this.listOfSubGroups = tmpExp;
                            this.loader = false;
                        }, 500);

                        // filtro quitar Grupos que contengan la palabra grupos
                        if (cargarFiltroSubgrupos == true) {
                            let filtroFind = this.listOfSubGroups.find((element) => element.groupId == this.model.groups[0]);
                            if (filtroFind != undefined) {
                                this.getTipos();
                                this.cargarFiltroSubgrupos = false;

                            }
                        }

                        // se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
                        if (this.arrayCopiaGroups.length != 0) {
                            this.arrayCopiaGroups.forEach((elementos) => {
                                let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                                let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                                if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                                    if (elementos.selected == true || elementos.selected == false) {
                                        this.duallistUserList.push(elementos);
                                    }
                                }
                            });

                            if (this.duallistGroupsList.length != 0) {
                                this.visible = true;
                            }
                        }
                        // se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
                    }
                });
        } else {
            this.subgruposUsuarios = false;
            // se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
            setTimeout(() => {
                if (this.arrayCopiaGroups.length != 0) {
                    this.arrayCopiaGroups.forEach((elementos) => {
                        let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                        let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                        if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                            if (elementos.selected == true || elementos.selected == false) {
                                this.duallistUserList.push(elementos);
                            }
                        }
                    });

                    if (this.duallistGroupsList.length != 0) {
                        this.visible = true;
                    }
                }
                this.loader = false;
            }, 500);
            //se cargan los usuarios previamente seleccionados cuando se hace un cambio en Grupos principal
        }

        this.nohaySeleccionados = !this.arrayCopiaGroups.every((elements) => elements.selected == undefined);
    }

    getTipos() {
        this.duallistUserList = [];

        if (!isNullOrUndefined(this.gruposFiltro)) {
            this.usersFind.idGroup = [];
            this.usersFind.idGroup.push(this.gruposFiltro);

            this.listOfTypes = [
                {
                    typeId: 'operaciones',
                    typeName: 'Operaciones'
                },
                {
                    typeId: 'mantenimiento',
                    typeName: 'Mantenimiento'
                },
                {
                    typeId: 'recuperadoresC',
                    typeName: 'Recuperadores Clientes'
                },
                {
                    typeId: 'recuperadoresE',
                    typeName: 'Recuperadores Equipos'
                },
                {
                    typeId: 'construccion',
                    typeName: 'Construccion'
                },
                {
                    typeId: 'operaciones migracion',
                    typeName: 'Operaciones migración'
                }
            ];

            this.getUsers();
        } else {
            this.visible = false;
            setTimeout(() => {
                if (this.arrayCopiaGroups.length != 0) {
                    this.arrayCopiaGroups.forEach((elementos) => {
                        let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                        let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                        if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                            if (elementos.selected == true || elementos.selected == false) {
                                this.duallistUserList.push(elementos);
                            }
                        }
                    });

                    if (this.duallistGroupsList.length != 0) {
                        this.visible = true;
                    }
                }
            }, 500);
        }

        this.nohaySeleccionados = !this.arrayCopiaGroups.every((elements) => elements.selected == undefined);
    }

    getUsers() {
        this.duallistUserList = [];
        if (!isNullOrUndefined(this.typeFiltro) && !isNullOrUndefined(this.gruposFiltro)) {
            delete (this.usersFind.extra3);
            this.usersFind.size = 100;
            this.usersFind.orderType = "asc";
            this.usersFind.orderColum = "username";
            this.usersFind.page = 0;
            this.visible = false;

            this.loadMoreUsers2(true);
        } else {
            this.visible = false;
            setTimeout(() => {
                if (this.arrayCopiaGroups.length != 0) {
                    this.arrayCopiaGroups.forEach((elementos) => {
                        let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                        let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                        if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                            if (elementos.selected == true || elementos.selected == false) {
                                this.duallistUserList.push(elementos);
                            }
                        }
                    });

                    if (this.duallistGroupsList.length != 0) {
                        this.visible = true;
                    }
                }
            }, 500);
        }

        this.nohaySeleccionados = !this.arrayCopiaGroups.every((elements) => elements.selected == undefined);
    }

    private loadMoreUsers2(reset: boolean): void {
        let tmp = [];
        this.bloqueado = true;
        this.loading = true;

        if (this.usersPage2.last && !reset) {
            this.bloqueado = false;
            this.loading = false;
            return;
        }

        if (reset) {
            this.usersFind.page = 0;
        } else if (this.usersFind.page <= this.usersPage2.totalPages) {
            this.usersFind.page++;
        }
        this.usersFind.agente = true;
        this.subscriptions.add(
            this.userService.findByGroups(this.usersFind)
                .subscribe((usersPage: any) => {
                        this.loading = true;
                        this.UsersPageUsers = usersPage;
                        this.usersPage2.totalPages = usersPage.totalPages;
                    }, (error) => {
                        this.visible = true;
                        this.loading = false;
                    }
                    , () => {
                        let usersList;
                        if (reset) {
                            usersList = [].concat(this.UsersPageUsers.content);
                        } else {
                            usersList = this.duallistUserList.concat(this.UsersPageUsers.content);
                        }
                        tmp = usersList;
                        usersList = [];
                        tmp.forEach((element) => {
                            if (PROFILE_IDS_ASIGNABLES_USERS_ACTIONS.indexOf(element.profileId) > -1) {
                                usersList.push(element);
                            }
                        });

                        //ordenamiento por username
                        usersList.sort(function (o1, o2) {
                            if (o1.username.toLowerCase() > o2.username.toLowerCase()) { //comparación lexicogŕafica
                                return 1;
                            } else if (o1.username.toLowerCase() < o2.username.toLowerCase()) {
                                return -1;
                            }
                            return 0;
                        });
                        //ordenamiento por username
                        this.usersPage2 = this.UsersPageUsers;
                        this.duallistUserList = usersList.map(users => new DuallistboxOption(users.idUserApp.toString(), users.username, this.model.users.indexOf(users.idUserApp.toString()) > -1));

                        if (this.arrayCopiaGroups.length != 0) {
                            this.arrayCopiaGroups.forEach((elementos) => {
                                let copiaGroupFound = this.arrayCopiaGroups.find((itemfound) => itemfound.key == elementos.key);
                                let duallistUserFound = this.duallistUserList.find((itemfound) => itemfound.key == elementos.key);
                                if (copiaGroupFound != undefined && duallistUserFound == undefined) {
                                    if (elementos.selected == true || elementos.selected == false) {
                                        this.duallistUserList.push(elementos);
                                    }
                                }
                            });

                            if (this.duallistGroupsList.length != 0) {
                                this.visible = true;
                                this.loading = false;
                            }
                        }

                        this.duallistUserList.forEach((element: any) => {
                            let found = this.arrayCopiaGroups.find((elemento) => elemento.key == element.key && elemento.selected == true);
                            let found2 = this.arrayCopiaGroups.find((elemento) => elemento.key == element.key && elemento.selected == false);
                            if (found != undefined) {
                                element.selected = true;
                            }
                            if (found2 != undefined) {
                                element.selected = true;
                            }
                        });

                        if (this.duallistGroupsList.length != 0) {
                            this.visible = true;
                            this.loading = false;
                        }

                        setTimeout(() => {
                            let x: any = document.getElementById('bootstrap-duallistbox-nonselected-list_users');
                            x.addEventListener('scroll', (event) => this.checkScrollViews(event));
                            this.newMaxScroll = 0;
                        }, 1000);

                        setTimeout(() => {
                            let x = document.querySelectorAll('.filter');
                            x[0].addEventListener('keyup', (event: any) => {
                                let nombre = event.target.value;
                                this.usersFind.userName = nombre;
                                if (event.key == 'Enter') {
                                    this.duallistUserList = [];
                                    this.visible = false;
                                    this.loadMoreUsers2(true);
                                }
                            });
                        }, 1000);
                        setTimeout(() => {
                            let input: any = document.querySelectorAll('.filter');
                            input[0].value = this.usersFind.userName;
                        }, 500);
                        this.bloqueado = false;
                    })
        );
    }

    private loadMoreUsers(reset: boolean): void {
        let tmp = [];
        this.bloqueado = true;
        this.visible = false;
        this.loading = true;

        if (this.usersPage2.last && !reset) {
            this.bloqueado = false;
            this.visible = true;
            this.loading = false;
            return;
        }

        if (reset) {
            this.usersFind.page = 0;
        } else if (this.usersFind.page <= this.usersPage2.totalPages) {
            this.usersFind.page++;
        }
        this.usersFind.agente = true;
        this.subscriptions.add(
            this.userService.findByGroups(this.usersFind)
                .subscribe((usersPage: any) => {
                        this.loading = true;
                        this.UsersPageUsers = usersPage;
                        this.usersPage2.totalPages = usersPage.totalPages;
                        this.usersPage2.number = this.usersFind.page;
                    }, (error) => {
                        this.visible = true;
                        this.loading = false;
                    }
                    , () => {
                        let usersList;
                        if (reset) {
                            usersList = [].concat(this.UsersPageUsers.content);
                        } else {
                            usersList = this.duallistUserList.concat(this.UsersPageUsers.content);
                        }
                        tmp = usersList;
                        usersList = [];
                        tmp.forEach((element) => {
                            if (PERFILES_ASIGNABLES_USERS_ACTIONS.indexOf(element.profileName) > -1) {
                                usersList.push(element);
                            }
                        });

                        //ordenamiento por username
                        usersList.sort(function (o1, o2) {
                            if (o1.username.toLowerCase() > o2.username.toLowerCase()) { //comparación lexicogŕafica
                                return 1;
                            } else if (o1.username.toLowerCase() < o2.username.toLowerCase()) {
                                return -1;
                            }
                            return 0;
                        });
                        //ordenamiento por username

                        this.usersPage2 = this.UsersPageUsers;

                        usersList.forEach((users) => {
                            let encontrado = this.arrayCopiaGroups.find((elemento) => elemento.key == users.idUserApp && elemento.selected == true);
                            if (encontrado == undefined) {
                                this.duallistUserList.push(new DuallistboxOption(users.idUserApp.toString(), users.username, undefined));
                            } else {
                            }
                            this.visible = false;
                            this.loading = true;
                        });
                        this.duallistUserList.sort((o1, o2) => Intl.Collator().compare(o1.value.toLowerCase(), o2.value.toLowerCase()));

                        // if(this.arrayCopiaGroups.length != 0){
                        //     this.arrayCopiaGroups.forEach((elementos)=>{
                        //      let copiaGroupFound = this.arrayCopiaGroups.find((itemfound)=> itemfound.key == elementos.key);
                        //      let duallistUserFound = this.duallistUserList.find((itemfound)=> itemfound.key == elementos.key);
                        //         if(copiaGroupFound != undefined && duallistUserFound == undefined){
                        //             if(elementos.selected == true || elementos.selected == false){
                        //                 this.duallistUserList.push(elementos);
                        //             }
                        //         }

                        //     });
                        // }

                        // this.duallistUserList.forEach((element:any) => {

                        //     let found = this.arrayCopiaGroups.find((elemento)=> elemento.key == element.key && elemento.selected == true);
                        //     let found2 = this.arrayCopiaGroups.find((elemento)=> elemento.key == element.key && elemento.selected == false);
                        //     if(found != undefined){
                        //         element.selected = true;
                        //     }
                        //     if(found2 != undefined){
                        //         element.selected = true;
                        //     }

                        // });
                        // this.duallistUserList = usersList;

                        // let subgroupFind = this.arrayCopiaGroups.find((element)=>element.key == )
                        // this.changeUsers(this.duallistUserList);
                        this.bloqueado = false;
                        setTimeout(() => {
                            this.visible = true;
                            this.loading = false;
                            setTimeout(() => {
                                let x: any = document.getElementById('bootstrap-duallistbox-nonselected-list_users');
                                x.addEventListener('scroll', (event) => this.checkScrollViews(event));
                                let cincoPorciento = (5 * this.newMaxScroll) / 100;
                                x.scrollTop = this.newMaxScroll - cincoPorciento;
                            }, 1000);
                        }, 100);
                    })
        );
    }

    @HostListener('scroll', ['$event'])
    onScroll(event) {
        alert(event);
    }

    changeUsers(data) {
        //let usersGroupsFinds = data.filter((elements)=> elements.selected);
        data.forEach((elementos) => {
            //  if(elementos.selected){
            let userfind = this.arrayCopiaGroups.find((element) => element.key == elementos.key);
            if (userfind == undefined) {
                this.arrayCopiaGroups.push(elementos);

            } else {
                let datafound = data.find((elemento) => elemento.key == userfind.key);
                if (datafound != undefined) {
                    userfind.selected = datafound.selected;
                }

                // let datafound2 = this.arrayCopiaGroups.find((elemento)=>elemento.key == userfind.key);
                // datafound2 = datafound;

                // if(userfind.selected === true){
                //     userfind.selected = false;
                // }else{

                // }
                // userfind.selected = true;
            }
            // }else{

            // }
        });

        if (data instanceof Array) {
            this.model.users = data.filter(user => user.selected).map(user => user.key);
            this.byUser.idGroups = this.model.users.map(u => +u);
        } else {
            this.model.users = data;
            this.byUser.idGroups.push(+data);
        }
    }

    @Input() data: any;

    toggleImageCrop() {
        this.imageCrop = !this.imageCrop;
    }

    ngOnDestroy() {
        if (this.bsModalRef) {
            this.bsModalRef.hide();
        }
    }

    ngOnInit() {
        this.setTranslations();
        this.searchAdvance.size = 100;
        this.searchAdvance.orderType = 'asc';
        this.usersFind.userName = '';

        this.pageTitle = this.route.snapshot.data.pageTitle;

        this.turnosService.getAll().subscribe(next => {
            this.workShifts = next;
        });
        /* revisar si es una accion valida y tiene permisos */
        if (!this.hasPermissionService.canAccess('EDIT_MAIL_AND_PHONE') && (this.action == 'update' || this.action == 'edit' || this.action == 'editar')) {
            this.disabledMailAndPhone = true;
        }
        if (this.hasPermissionService.canAccess('DELETE_UUID')){
            console.log(this.action)
            console.log(this.viewProfile)
            if(this.action == 'edit' && !this.viewProfile){
                this.showuuid = false;
            }else if(this.action == 'add' && this.viewProfile){
                this.showuuid == false;
            }else if(this.action == 'view' && this.viewProfile){
                this.showuuid = false
            }else{
                this.showuuid = true;
            }
            
        }
        if (!this.viewProfile) {
            this.tabs = [
                {
                    title: 'GENERAL',
                    active: true,
                }
            ];
        }

        

        //cargar los datos del usuario logeado
        this.service.get(this.authorization.token.userId).subscribe(success => {
            if(success.userAppView.extraConfiguration.iam[0] == 3){
                if(success.userAppView.extraConfiguration.editarPerfil != true){
                    this.model.extraConfiguration.editarPerfil = true;
                    this.disablePerfil = true;
                    this.cdr.detectChanges();
                }
            }
            this.idProfileLogged = success.userAppView.profileId;
            if ((this.idProfileLogged === 26 || this.idProfileLogged === 35 || this.idProfileLogged === 106) && this.viewProfile) {
                this.tabs = [
                    {
                        title: 'GEOCERCAS',
                        active: true,
                    }
                ];
            }
            if (this.hasPermissionService.canAccess('validate.security.key') || (this.idProfileLogged == 1 || this.idProfileLogged == 71))
            {
                this.showValidateSecurityKey = true;
                this.model.extraConfiguration.mdm = true;
                this.model.extraConfiguration.e2e = true;
                
            }
            if (this.hasPermissionService.canAccess('validate.device'))
            {   
                this.showValidateDevice = true;
            }
            if (success.userAppView.user_dimme != null) {
                this.model.user_dimme = success.userAppView.user_dimme; 
            }
            else {
                if (success.userAppView.extraConfiguration.dum.ne && typeof success.userAppView.extraConfiguration.dum.ne == 'number') {
                    this.model.user_dimme = true;
                }
                else {
                    this.model.user_dimme = false;
                }
            }
        });

        

        
        this.FormValidacion =
            this.formBuilder.group({
                username: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                password: [this.model.password, [Validators.minLength(8),
                    Validators.maxLength(8),
                    Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                    Validators.maxLength(8),
                    Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                name: ['', [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                email: ['', [Validators.email]],//,Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
                numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                userProfile: [null, [Validators.required]],
                turnoLaboral: ['', [Validators.required]],
                Sucursal: ['', [Validators.pattern('^[0-9]*$')]],
                Cuadrilla: ['', [Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                noVendedor: ['', [Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
                maxTimeOnTicket: [30, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                Tipo: [''],
                att: [''],
                AutoAssigne: [''],
                Estatus: [''],
                AutoAgendado: [''],
                Dum: [''],
                e2e: [''],
                pagos: [''],
                quiosco:[''],
                validarEquipo:[''],
                mdm:[''],
                metrospre: [500],
                tmm: [60],
                ntm: [''],
                dashProd: [''],
                vtw: [false],
                bulk: [false],
                user_dimme: [true],
            });

        this.ticketTypeService.getInfoTiposTicket(new TicketTypeRequestView()).subscribe((args) => {
            args.sort((o1, o2) => Intl.Collator().compare(o1.ticketType.toLowerCase(), o2.ticketType.toLowerCase()));
            this.listOfTypes2 = args;
        });

        let accessChecked: boolean = false;

        switch (this.action) {
            case 'add':
            case 'agregar':
                if (!this.hasPermissionService.canAccess('create.user')) this.Cancel();
                this.userService.getTreeGroups().subscribe((success: any) => {
                    console.log('Agregar',success)
                    success.sort((o1, o2) => Intl.Collator().compare(o1.content.toLowerCase(), o2.content.toLowerCase()));
                    for (let index = 0; index < success.length; index++) {
                        success[index].children.sort((o1, o2) => Intl.Collator().compare(o1.content.toLowerCase(), o2.content.toLowerCase()));
                    }
                    //se crea un array con objetos de sucursales con ids hijos y padres
                    success.forEach(sucursalPrincipal => {
                        let idSucursalPincipal = sucursalPrincipal.id;
                        let nameSucursalPincipal = sucursalPrincipal.content;
                        this.gruposObject.push({
                            idSucursalPincipal: idSucursalPincipal,
                            nameSucursalPrincipal: nameSucursalPincipal,
                            idSucursalPadre: idSucursalPincipal,
                            nameSucursalPadre: nameSucursalPincipal,
                            idSucursalHija: idSucursalPincipal,
                            nameSucursalHija: nameSucursalPincipal,
                        });
                        if (sucursalPrincipal.children.length > 0) {
                            sucursalPrincipal.children.forEach(sucursalPadre => {
                                let idSucursalPadre = sucursalPadre.id;
                                let nameSucursalPadre = sucursalPadre.content;
                                this.gruposObject.push({
                                    idSucursalPincipal: idSucursalPincipal,
                                    nameSucursalPrincipal: nameSucursalPincipal,
                                    idSucursalPadre: idSucursalPadre,
                                    nameSucursalPadre: nameSucursalPadre,
                                    idSucursalHija: idSucursalPadre,
                                    nameSucursalHija: nameSucursalPadre
                                });
                                if (sucursalPadre.children.length > 0) {
                                    sucursalPadre.children.forEach(sucursalHija => {
                                        let idSucursalHija = sucursalHija.id;
                                        let nameSucursalHija = sucursalHija.content;
                                        this.gruposObject.push({
                                            idSucursalPincipal: idSucursalPincipal,
                                            nameSucursalPrincipal: nameSucursalPincipal,
                                            idSucursalPadre: idSucursalPadre,
                                            nameSucursalPadre: nameSucursalPadre,
                                            idSucursalHija: idSucursalHija,
                                            nameSucursalHija: nameSucursalHija
                                        });
                                    })
                                }
                            });
                        }
                    });
                    //se crea un array con objetos de sucursales con ids hijos y padres   
                    // this.groupsTree = success;
                    const dataFromService: Principals[] = success;/* Obtén la data del servicio aquí */;
                    const groupedData = this.groupDataByRegions(dataFromService);
                    const validateDataActiveZona = this.validateAllActive(groupedData);
                    //this.logZonasAndChildren(validateDataActiveZona);
                    // if(
                    //     //Administrador Mantenimiento
                    //     this.idProfileLogged == 70 ||
                    //     //Jefe Mantenimiento
                    //     this.idProfileLogged == 73 ||
                    //     //Radio Operador MYC (N1)
                    //     this.idProfileLogged == 82 ||
                    //     //Supervisor De Radio Operador MYC (N1)
                    //     this.idProfileLogged == 102 ||
                    //     //Supervisor Mantenimiento
                    //     this.idProfileLogged == 78 ||
                    //     //Administrador Mantenimiento Wifi
                    //     this.idProfileLogged == 158 || 
                    //     //Jefe de Infraestructura Pi
                    //     this.idProfileLogged == 159 || 
                    //     //Administrador Pi 
                    //     this.idProfileLogged == 163  ||
                    //     //Supervisor Pi e Infra
                    //     this.idProfileLogged == 165
                    // ){
                        this.groupsTree = validateDataActiveZona;
                    // }
                }, error => {
                    if (error) {
                        this.createNotification('warning', 'No se pudo cargar los grupos', 'No se pudieron cargar los grupos');
                    }
                });
                // if (!this.hasPermissionService.canAccess('UPDATE_GENERAL_INFO')){
                //     this.tabs.splice(0,1)
                // }else{
                    if(this.hasPermissionService.canAccess('ADD_ADMINISTRATORS')){
                        this.listOfProfiles = this.listOfProfilescopie.filter((item) => item.idTypeTicket == Number(this.extraConfiguracion))
                    }else{
                        this.listOfProfiles = this.listOfProfilescopie.filter((item) => 
                        item.idTypeTicket == Number(this.extraConfiguracion) && !item.profileName.toLowerCase().includes('administrador'))
                    }
                   
                    // this.hideGeneralInfo = false
                // }
                // if (!this.hasPermissionService.canAccess('UPDATE_GROUPS')){
                //     this.tabs.splice(0,1)
                // }else{
                //     this.hideGroups= false
                // }
                // if (!this.hasPermissionService.canAccess('UPDATE_GEOCERCA')){
                //     this.tabs.splice(0,1)
                // }else{
                //     this.hideGeo = false
                // }
                // if (!this.hasPermissionService.canAccess('EDIT_USERS')){
                //     this.tabs.splice(0,1)
                // }else{
                //     this.hideUSers = false
                // }
                // if (this.hasPermissionService.canAccess('UPDATE_USER_PERMISSION')){
                //     this.viewPermission = true;
                //     this.tabs.push({
                //         title: 'PERMISOS',
                //         active: false
                //     });
                // }
                break;
            case 'update':
            case 'edit':
            case 'editar':
                accessChecked = true;
                if (!this.hasPermissionService.canAccess('update.user')) this.Cancel();
                if (this.model.status.toString() == 'ACTIVO') {
                    this.model.status = true;
                }
                if (this.model.status.toString() == 'INACTIVO') {
                    this.model.status = false;
                }
                this.FormValidacion =
                    this.formBuilder.group({
                        username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                        password: [this.model.password, [Validators.minLength(8),
                            Validators.maxLength(8),
                            Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                        passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                            Validators.maxLength(8),
                            Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                        name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                        email: [this.model.email.value, [Validators.email]],
                        numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                        userProfile: [this.model.profile, [Validators.required]],
                        turnoLaboral: [this.idWorkShift, [Validators.required]],
                        Sucursal: [this.model.extra1],
                        Cuadrilla: [this.model.extra2, [Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                        noVendedor: [this.model.extraConfiguration.nvm],
                        maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                        Tipo: [this.extraConfiguracion],
                        att: [this.tipoTecnologia],
                        AutoAssigne: [this.model.extra4],
                        Estatus: [this.model.status],
                        AutoAgendado: [this.model.extra5],
                        Dum: [this.model.extraConfiguration.dum.ne],
                        e2e: [this.model.extraConfiguration.e2e? this.model.extraConfiguration.e2e: true],
                        bulk: [this.model.extraConfiguration.bulk? this.model.extraConfiguration.bulk: false],
                        priorizar: [this.model.extraConfiguration.priorizar? this.model.extraConfiguration.priorizar: false],
                        pagos: [this.model.extraConfiguration.pagos],
                        quiosco: [this.model.extraConfiguration.quiosco],
                        validarEquipo: [this.model.extraConfiguration.validarEquipo],
                        mdm: [this.model.extraConfiguration.mdm],
                        metrospre: [this.model.extraConfiguration.metrospre],
                        device: [this.model.extraConfiguration.device],
                        externa: [this.model.extraConfiguration.externa],
                        cuadlog: [this.model.extraConfiguration.cuadlog],
                        autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                        vtw: [this.model.extraConfiguration.vtw],
                        agendex: [this.model.extraConfiguration.agendex],
                        tmm: [this.model.extraConfiguration.tmm ? this.model.extraConfiguration.tmm : 60],
                        ntm: [this.model.extraConfiguration.ntm],
                        dashProd: [this.model.extraConfiguration.dashProd],
                        editarPerfil: [this.model.extraConfiguration.editarPerfil],
                        user_dimme: [this.model.user_dimme],
                    });
            case 'view':
            case 'ver':
                if (!accessChecked && !this.hasPermissionService.canAccess('view.user')) {
                    this.Cancel();
                }
                this.readonly = !accessChecked;
                //revisar que se haya mandado un id en parametross
                if (!this.id || isNaN(this.id)) this.Cancel();
                this.service.get(this.id, true, true).subscribe(success => {
                    this.model.name = success.userAppView.name;
                    this.model.userName = success.userAppView.username;
                    this.model.realUserName = success.userAppView.username;
                    this.model.email.value = success.userAppView.email;
                    this.model.numTel = success.userAppView.numTel;
                    this.model.extra1 = success.userAppView.extra1;
                    this.model.extra2 = success.userAppView.extra2;
                    this.model.extra4 = success.userAppView.extra4;
                    this.model.extra5 = success.userAppView.extra5;
                    this.model.status = success.userAppView.status;
                    this.model.extraConfiguration.att = success.userAppView.extraConfiguration.att;
                    // this.imageProfile = success.userAppView.imageProfile;
                    this.idWorkShift = success.idWorkShift;
                    this.model.extraConfiguration.e2e = success.userAppView.extraConfiguration.e2e?success.userAppView.extraConfiguration.e2e: false;
                    this.model.extraConfiguration.bulk = success.userAppView.extraConfiguration.bulk?success.userAppView.extraConfiguration.bulk: false;
                    this.model.extraConfiguration.priorizar = success.userAppView.extraConfiguration.priorizar?success.userAppView.extraConfiguration.priorizar: false;
                    this.model.extraConfiguration.idquiosco = success.userAppView.extraConfiguration.idquiosco?success.userAppView.extraConfiguration.idquiosco: null;
                    this.model.extraConfiguration.quiosco = success.userAppView.extraConfiguration.quiosco?success.userAppView.extraConfiguration.quiosco: null;
                    this.model.extraConfiguration.validarEquipo = success.userAppView.extraConfiguration.validarEquipo?success.userAppView.extraConfiguration.validarEquipo: false;
                    this.model.extraConfiguration.mdm = success.userAppView.extraConfiguration.mdm?success.userAppView.extraConfiguration.mdm: false;
                    this.model.extraConfiguration.metrospre = success.userAppView.extraConfiguration.metrospre ? success.userAppView.extraConfiguration.metrospre : 500,
                    this.model.extraConfiguration.device = success.userAppView.extraConfiguration.device?success.userAppView.extraConfiguration.device: false;
                    this.model.extraConfiguration.externa = success.userAppView.extraConfiguration.externa?success.userAppView.extraConfiguration.externa: false;
                    this.model.extraConfiguration.cuadlog = success.userAppView.extraConfiguration.cuadlog?success.userAppView.extraConfiguration.cuadlog: false;
                    this.model.extraConfiguration.autoasgeoale = success.userAppView.extraConfiguration.autoasgeoale?success.userAppView.extraConfiguration.autoasgeoale: false;
                    this.model.extraConfiguration.vtw = success.userAppView.extraConfiguration.vtw?success.userAppView.extraConfiguration.vtw: false;
                    this.model.extraConfiguration.agendex = success.userAppView.extraConfiguration.agendex?success.userAppView.extraConfiguration.agendex: false;
                    this.model.extraConfiguration.tmm = success.userAppView.extraConfiguration.tmm?success.userAppView.extraConfiguration.tmm: 60;
                    this.model.extraConfiguration.ntm = success.userAppView.extraConfiguration.ntm?success.userAppView.extraConfiguration.ntm: false;
                    this.model.extraConfiguration.dashProd = success.userAppView.extraConfiguration.dashProd?success.userAppView.extraConfiguration.dashProd: false;

                    this.model.extraConfiguration.pagos = success.userAppView.extraConfiguration.pagos?success.userAppView.extraConfiguration.pagos: false;
                    this.model.extraConfiguration.editarPerfil = success.userAppView.extraConfiguration.editarPerfil;
                    if (success.userAppView.user_dimme != null) {
                        this.model.user_dimme = success.userAppView.user_dimme;
                    }
                    else {
                        if (success.userAppView.extraConfiguration.dum.ne && typeof success.userAppView.extraConfiguration.dum.ne == 'number') {
                            this.model.user_dimme = true;
                        }
                        else {
                            this.model.user_dimme = false;
                        }
                    }
                    //Seteando la data del tipo Tecnologia al formulario
                    //extraconfiguration.iam contiene el tipo trabajo, 3 = operaciones
                    if( success.userAppView.extra4 == true &&
                        success.userAppView.extraConfiguration.iam[0] == 3){
                      this.isOperations = true;
                      this.tipoTecnologia = this.model.extraConfiguration.att;
                      if( this.tipoTecnologia == 1 ){
                        this.tipoTecnologia = "Coaxial";
                      }
                      if( this.tipoTecnologia == 2 ){
                        this.tipoTecnologia = "Fibra";
                      }
                      if( this.tipoTecnologia == 0 || !this.tipoTecnologia ){
                        this.tipoTecnologia = "Todos";
                      }
                    }
                    //**************************************************
                    if (this.action == 'editar' && success.userAppView.imageProfile === null) {
                        // this.imageProfile = new ImageProfile();
                    } else {
                        this.imageProfile = success.userAppView.imageProfile;
                    }
                    if (success.userAppView.extraConfiguration != null) {
                        if (success.userAppView.extraConfiguration.iam.length != 0) {
                            success.userAppView.extraConfiguration.iam.forEach((element) => {
                                this.extraConfiguracion = element;
                            });
                        } else {
                            this.extraConfiguracion = null;
                        }
                        if(this.extraConfiguracion == 5 && (this.idProfileLogged == 1 || this.idProfileLogged == 71) ){
                            this.showe2e = true;
                        }
                        
                        if (success.userAppView.extraConfiguration.dum != null) {
                            if (success.userAppView.extraConfiguration.dum.ne != null) {
                                this.model.extraConfiguration.dum.ne = success.userAppView.extraConfiguration.dum.ne;
                            } else {
                                this.model.extraConfiguration.dum.ne = null;
                            }
                        } else {
                            this.model.extraConfiguration.dum.ne = null;
                        }

                        if (success.userAppView.extraConfiguration.nvm != null) {
                            this.model.extraConfiguration.nvm = success.userAppView.extraConfiguration.nvm;
                        } else {
                            this.model.extraConfiguration.nvm = null;
                        }

                        if (success.userAppView.extraConfiguration.tmad) {
                            this.model.extraConfiguration.tmad = success.userAppView.extraConfiguration.tmad;
                        }
                    }
                    this.model.userGeofenceViewList = success.userAppView.userGeofenceViewList;
                    this.model.userGeofenceAlertViewList = success.userAppView.userGeofenceAlertViewList;
                    this.model.profile = success.userAppView.profileId;
                    this.model.permissionsList = success.userAppView.permissionsList;
                    const findPermission = success.userAppView.permissionsList.find((permissionId) => permissionId == 132);
                    if (findPermission) {
                        this.havePremisionEditPermsisions = true;
                    }

                    if (this.action == 'editar') {
                        this.crearFormVAlido();
                    }
                    // if(this.model.profile == 27){
                    //     this.esAgente = true;
                    // }else{this.esAgente = false;}

                    this.userService.getTreeSelectGroups(this.id).subscribe((success: any) => {
                        success.sort((o1, o2) => Intl.Collator().compare(o1.content.toLowerCase(), o2.content.toLowerCase()));
                        for (let index = 0; index < success.length; index++) {
                            success[index].children.sort((o1, o2) => Intl.Collator().compare(o1.content.toLowerCase(), o2.content.toLowerCase()));
                        }
                        //se crea un array con objetos de sucursales con ids hijos y padres
                        success.forEach(sucursalPrincipal => {
                            let idSucursalPincipal = sucursalPrincipal.id;
                            let nameSucursalPincipal = sucursalPrincipal.content;
                            this.gruposObject.push({
                                idSucursalPincipal: idSucursalPincipal,
                                nameSucursalPrincipal: nameSucursalPincipal,
                                idSucursalPadre: idSucursalPincipal,
                                nameSucursalPadre: nameSucursalPincipal,
                                idSucursalHija: idSucursalPincipal,
                                nameSucursalHija: nameSucursalPincipal,
                            });
                            if (sucursalPrincipal.children.length > 0) {
                                sucursalPrincipal.children.forEach(sucursalPadre => {
                                    let idSucursalPadre = sucursalPadre.id;
                                    let nameSucursalPadre = sucursalPadre.content;
                                    this.gruposObject.push({
                                        idSucursalPincipal: idSucursalPincipal,
                                        nameSucursalPrincipal: nameSucursalPincipal,
                                        idSucursalPadre: idSucursalPadre,
                                        nameSucursalPadre: nameSucursalPadre,
                                        idSucursalHija: idSucursalPadre,
                                        nameSucursalHija: nameSucursalPadre
                                    });
                                    if (sucursalPadre.children.length > 0) {
                                        sucursalPadre.children.forEach(sucursalHija => {
                                            let idSucursalHija = sucursalHija.id;
                                            let nameSucursalHija = sucursalHija.content;
                                            this.gruposObject.push({
                                                idSucursalPincipal: idSucursalPincipal,
                                                nameSucursalPrincipal: nameSucursalPincipal,
                                                idSucursalPadre: idSucursalPadre,
                                                nameSucursalPadre: nameSucursalPadre,
                                                idSucursalHija: idSucursalHija,
                                                nameSucursalHija: nameSucursalHija
                                            })
                                        })
                                    }
                                });
                            }
                        });
                        //se crea un array con objetos de sucursales con ids hijos y padres
                        // this.groupsTree = success;
                        const dataFromService: Principals[] = success;/* Obtén la data del servicio aquí */;
                        const groupedData = this.groupDataByRegions(dataFromService);
                        const validateDataActiveZona = this.validateAllActive(groupedData);
                        //this.logZonasAndChildren(validateDataActiveZona);
                        // if(
                        //     //Administrador Mantenimiento
                        //     this.idProfileLogged == 70 ||
                        //     //Jefe Mantenimiento
                        //     this.idProfileLogged == 73 ||
                        //     //Radio Operador MYC (N1)
                        //     this.idProfileLogged == 82 ||
                        //     //Supervisor De Radio Operador MYC (N1)
                        //     this.idProfileLogged == 102 ||
                        //     //Supervisor Mantenimiento
                        //     this.idProfileLogged == 78 ||
                        //     //Administrador Mantenimiento Wifi
                        //     this.idProfileLogged == 158 || 
                        //     //Jefe de Infraestructura Pi
                        //     this.idProfileLogged == 159 || 
                        //     //Administrador Pi 
                        //     this.idProfileLogged == 163 ||
                        //     //Supervisor Pi e Infra
                        //     this.idProfileLogged == 165
                        // ){
                            this.groupsTree = validateDataActiveZona;
                        // }
                        if (this.readonly) {
                            this.readonlyTree(this.groupsTree);
                        }
                    }, (error) => {
                        setTimeout(() => {
                            this.createNotification('warning', 'Grupos no obtenidos', 'No se puede obtener el grupos');
                        }, 500);
                    });
                    // if ((this.model.profile === 134 || this.model.profile === 27 || this.model.profile === 94 || this.model.profile === 30 || this.model.profile === 64 || this.model.profile === 63 || this.model.profile == 34 || this.model.profile === 88 || this.model.profile == 92 || this.model.profile == 130 || this.model.profile === 103) && (this.idProfileLogged != 26) && (this.idProfileLogged != 106)) {
                    //     this.tabs = [
                            
                    //     ];
                    // }
                    this.tabs = [
                            
                    ];
                    
                    if(this.hasPermissionService.canAccess('ADD_ADMINISTRATORS')){
                        this.listOfProfiles = this.listOfProfilescopie.filter((item) => item.idTypeTicket == Number(this.extraConfiguracion))
                    }else{
                        this.listOfProfiles = this.listOfProfilescopie.filter((item) => 
                        item.idTypeTicket == Number(this.extraConfiguracion) && !item.profileName.toLowerCase().includes('administrador'))
                    }
                    
                    if (!this.hasPermissionService.canAccess('UPDATE_GENERAL_INFO')){
                        this.hideGeneralInfo = true
                    }else{
                        this.tabs.push({
                            title: 'GENERAL',
                            active: false,
                        })
                    }
                    if (!this.hasPermissionService.canAccess('UPDATE_GROUPS')){
                        this.hideGroups= true
                    }else{
                        this.tabs.push({
                            title: 'GRUPOS',
                            active: false,
                        })
                    }
                    if (!this.hasPermissionService.canAccess('EDIT_USERS')){
                        this.hideUSers = true
                    }else{
                        this.tabs.push({
                            title: 'USUARIOS',
                            active: false,
                        })
                    }
                    if (!this.hasPermissionService.canAccess('UPDATE_GEOCERCA')){
                        this.hideGeo = true
                    }else{
                        this.tabs.push({
                            title: 'GEOCERCAS',
                            active: false,
                        })
                    }
                    if (this.hasPermissionService.canAccess('UPDATE_USER_PERMISSION')){
                        this.viewPermission = true;
                        this.tabs.push({
                            title: 'PERMISOS',
                            active: false
                        });
                    }

                    // obtener lista de geocercas
                    this.searchAdvance.idTypeTicket = this.extraConfiguracion;
                    this.searchAdvance.geofenceType = 1;
                    this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                        this.geofencesArray = this.geofencesArray.concat(geofences.content);
                        this.availableItems = [];
                        this.selectedItems = [];
                        this.geofencesArray.forEach((element) => {
                            this.availableItems.push({
                                id: element.idGeofence.toString(),
                                name: element.name,
                                val: element.idGeofence.toString()
                            });
                        });
                        // si es ver o editar
                        if (this.action === 'view' || this.action === 'ver' || this.action === 'edit' || this.action === 'editar' || this.action === 'update') {
                            if (this.model.userGeofenceViewList.length > 0) {
                                this.model.userGeofenceViewList.sort((o1, o2) => Intl.Collator().compare(o1.priorityGeofence, o2.priorityGeofence));
                                this.model.userGeofenceViewList.forEach(geoList => {
                                    // this.geofencesArray.forEach(geo => {
                                    //     if (geo.idGeofence === geoList.idGeofence) {
                                    //         this.selectedItems.push({
                                    //             id: geo.idGeofence.toString(),
                                    //             name: geo.name,
                                    //             val: geo.idGeofence.toString()
                                    //         });
                                    this.currentSelectItems.push({
                                        value: geoList.idGeofence.toString(),
                                        text: geoList.geofenceName,
                                    });
                                    this.selectedItems.push({
                                        id: geoList.idGeofence.toString(),
                                        name: geoList.geofenceName,
                                        val: geoList.idGeofence.toString()
                                    });
                                    //     }
                                    // });
                                });
                                this.selectedItems.forEach(selec => {
                                    this.availableItems.forEach((avalible, index) => {
                                        if (avalible.id === selec.id) {
                                            this.availableItems.splice(index, 1);
                                        }
                                    });
                                });

                                this.availableItems.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));
                            }
                        }
                    }, (error) => {
                        console.error('error al cargar las geocercas', error);
                    });
                    /** termina obtener lista de geocercas*/
                    /** geocercas elertas */
                    this.searchAdvance.geofenceType = 2;
                    this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                        this.geofencesAlertArray = this.geofencesAlertArray.concat(geofences.content);
                        this.availableItemsAlert = [];
                        this.selectedItemsAlert = [];
                        this.geofencesAlertArray.forEach((element) => {
                            this.availableItemsAlert.push({
                                id: element.idGeofence.toString(),
                                name: element.name,
                                val: element.idGeofence.toString()
                            });
                        });
                        if (this.action === 'view' || this.action === 'ver' || this.action === 'edit' || this.action === 'editar' || this.action === 'update') {
                            if (this.model.userGeofenceAlertViewList.length > 0) {
                                this.model.userGeofenceAlertViewList.forEach(geoList => {
                                    this.currentSelectItemsAlert.push({
                                        value: geoList.idGeofence.toString(),
                                        text: geoList.geofenceName,
                                    });
                                    this.selectedItemsAlert.push({
                                        id: geoList.idGeofence.toString(),
                                        name: geoList.geofenceName,
                                        val: geoList.idGeofence.toString()
                                    });
                                });
                                this.selectedItemsAlert.forEach(selec => {
                                    this.availableItemsAlert.forEach((avalible, index) => {
                                        if (avalible.id === selec.id) {
                                            this.availableItemsAlert.splice(index, 1);
                                        }
                                    });
                                });

                                this.availableItemsAlert.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));
                            }
                        }


                    }, (error) => {
                        console.error('error al cargar las geocercas alerta', error);
                    });
                    /** termina geocercas elertas */


                    /** mapeando lista de usuarios**/
                    // this.model.viewInScheduleViewList = success.viewInScheduleViewList;
                    success.userAppView.projectionViewInScheduleView.forEach(user => {
                        this.model.viewInScheduleViewList.push({
                            idToViewInSchedule: user.idUserApp,
                        });
                    });
                    /** terminamos de mapear lista de usuarios**/

                    /** obteniendo lista de usuarios*/
                        // ajustar los grupos cuando se regrese el arreglo Gloria
                    let idGrupoUser;
                    idGrupoUser = success.userAppView.groups[0].groupId;


                    // let regExp = /^[a-zA-Z]+\-+([0-9])*$/;
                    // this.bandExpRegCuadrilla = !(regExp.test(this.model.extra2) || this.model.extra2 == '');

                    /*if (this.viewProfile) {

                    }else{
                        //idGrupoUser = 127;
                    }*/

                    //comentado Otniel 2 septiembre
                    // this.service.findByGroups(idGrupoUser).subscribe(users1 => {
                    //     let tmp = [];
                    //     tmp = users1;
                    //     users1 = [];
                    //     // console.log(tmp);

                    //     tmp.forEach((element) => {
                    //         if (element.profileName == "Agente"){
                    //             users1.push(element);
                    //         }


                    //     });
                    //     //---------------------ordenamiento por name------------------------------------
                    //     users1.sort((o1,o2)=>Intl.Collator().compare(o1.username.toLowerCase(),o2.username.toLowerCase()));
                    //     //---------------------ordenamiento por name------------------------------------
                    //     this.duallistUserList = users1.map(users => new DuallistboxOption(users.idUserApp.toString(), users.username, this.model.users.indexOf(users.idUserApp.toString()) > -1));
                    //     this.model.viewInScheduleViewList.forEach((userSchedule) => {
                    //         this.duallistUserList.forEach((userList, index) => {
                    //             if (userList.key === userSchedule.idToViewInSchedule.toString()) {
                    //                 this.duallistUserList[index].selected = true;
                    //             }
                    //         });
                    //     });
                    // });
                    //comentado Otniel 2 septiembre

                    /**termina de obtener lista de usuarios*/

                        this.getTreeProfile();



                    success.userAppView.groupList.forEach((group) => this.model.groups.push("" + group));
                    this.byprofile.idGroups = this.model.groups;
                    this.byprofile.idProfile = success.userAppView.profileId;
                    // comentado el 11 de diciembre del 2020
                    this.underProfileList = success.userAppView.infoUsers;
                    if (this.listOfGroups.length && this.model.groups.length)
                        this.duallistGroupsList = this.listOfGroups.map(group => new DuallistboxOption(group.groupId.toString(), group.groupName, this.model.groups.indexOf(group.groupId.toString()) > -1));
                    /**opteniendo lista de usuarios**/
                    this.underProfileList = success.userAppView.infoUsers.map(user => new DuallistboxOption(user.idUser.toString(), user.nameUser, user.selected));
                    success.userAppView.infoUsers.forEach(e => {
                        if (e.selected) {
                            this.usersGeofenceList.push(e.idUser);
                        }
                    });
                    // comentado el 11 de diciembre del 2020

                    // success.extraList.forEach((info) => {
                    //     this.extraInfo.push(
                    //         $.extend(info, {
                    //             error: false,
                    //             updating: false
                    //         })
                    //     );
                    // });
                    if (this.model.status.toString() == 'ACTIVO') {
                        this.model.status = true;
                    }
                    if (this.model.status.toString() == 'INACTIVO') {
                        this.model.status = false;
                    }
                    if (this.model.profile == 134 ||this.model.profile == 27 || this.model.profile == 94 || this.model.profile == 30 || this.model.profile == 63 || this.model.profile == 64 || this.model.profile == 34 || this.model.profile === 88 || this.model.profile == 130 || this.model.profile == 103 || this.model.profile == 175 || this.model.profile == 156) {
                        jQuery('#usuariosTab2').addClass('hideElement');
                    }

                    this.gruposFiltro = null;
                    this.cargarFiltroSubgrupos = true;
                    this.getSubgroups(this.model.groups, this.cargarFiltroSubgrupos);
                    this.subgruposUsuarios = true;

                    this.usersFind.size = 100;
                    this.usersFind.orderType = "asc";
                    this.usersFind.orderColum = "username";
                    this.usersFind.page = 0;

                    if (success.userAppView.projectionViewInScheduleView.length != 0) {
                        success.userAppView.projectionViewInScheduleView.forEach((elementos) => {
                            this.arrayCopiaGroups.push(new DuallistboxOption(elementos.idUserApp.toString(), elementos.userName, true));
                            this.getUsers();
                        });
                    }

                    // this.model.extraConfiguration.pagos=true;
                    // this.model.extraConfiguration.quiosco="PayPal Web";
                    // this.model.extraConfiguration.idquiosco=16;
   
                     console.log('USUARIO',this.model)
                       this.userService.ObtenerQuiosco(this.model.extra1).subscribe((resp)=>{
                           console.log('QUIOSCO',resp.entidad_externa)
                           this.listOfQuioscos=resp.entidad_externa;
                       },(error)=>{
                           console.log('error',error);
                       });
                    if (this.action == 'update' || this.action == 'edit' || this.action == 'editar')
                        this.validateCanEditByProfile();
                }, error => {
                    let errorMsg: string;
                    if (!!error.code) {
                        errorMsg = '<i>Error: ' + error.code + '</i><br>';
                        if (!!error.errorList.length) errorMsg += error.errorList[0];
                        else errorMsg += error.message;
                    }
                    this.notifications.bigBox({
                        title: this.errorContent4,
                        content: errorMsg,
                        color: "#C46A69",
                        icon: "fa fa-warning shake animated",
                        timeout: 6000
                    });
                    this.Cancel();
                    this.cerrarModal();
                });
                break;
            default:
                this.Cancel();
                break;
        }
        /* ~ */
        this.profileService.getAll().subscribe(success => {
            this.listOfProfiles = success;
            this.listOfProfiles.sort(function (o1, o2) {
                if (o1.profileName.toLowerCase() > o2.profileName.toLowerCase()) {
                    return 1;
                } else if (o1.profileName.toLowerCase() < o2.profileName.toLowerCase()) {
                    return -1;
                }
                return 0;
            });

            this.listOfProfilescopie = this.listOfProfiles;
            // this.removeAllAdministrators();
            if (localStorage.getItem('info_user_logged') !== undefined && localStorage.getItem('info_user_logged')) {
                this.infoUserLogged = JSON.parse(localStorage.getItem('info_user_logged'));
                if (this.infoUserLogged.userAppView.profileId != 1){
                    this.listOfProfiles.forEach((avalible, index) => {
                        //esta validacion quita el perfil de administrador del sistema si la persona logueada no es un administrador de sistema
                        if (avalible.profileId === 1) {
                            this.listOfProfiles.splice(index, 1);
                        }
                    });
                    this.listOfProfilescopie = this.listOfProfiles;
                    
                }
            }
            this.removeAllAdministrators();
        }, () => {
            this.notifications.bigBox({
                title: this.errorContent5,
                content: this.errorContent6,
                color: "#C46A69",
                icon: "fa fa-warning shake animated",
                timeout: 6000
            });
            this.Cancel();
        });
        this.groupService.getAll().subscribe(success => {
            //---------------------ordenamiento por groupName------------------------------------
            success.sort((o1, o2) => Intl.Collator().compare(o1.groupName.toLowerCase(), o2.groupName.toLowerCase()));            
            //---------------------ordenamiento por groupName------------------------------------
            this.listOfGroups = success;
            if (this.listOfGroups.length && this.model.groups.length || (this.action == 'add' || this.action == 'agregar')) {
                this.duallistGroupsList = this.listOfGroups.map(group => new DuallistboxOption(group.groupId.toString(), group.groupName, this.model.groups.indexOf(group.groupId.toString()) > -1));
            }
        }, () => {
            this.notifications.bigBox({
                title: this.errorContent7,
                content: this.errorContent8,
                color: "#C46A69",
                icon: "fa fa-warning shake animated",
                timeout: 6000
            });
            this.Cancel();
        });

        this.FormValidacion.controls['user_dimme'].valueChanges.subscribe(()=>{
            this.userDimmeValidado = false;
        });

        // obtener lista de geocercas operativas
        if (this.action === 'add' || this.action === 'agregar') {
            this.searchAdvance.geofenceType = 1;
            this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                this.geofencesArray = this.geofencesArray.concat(geofences.content);
                this.availableItems = [];
                this.selectedItems = [];
                this.geofencesArray.forEach((element) => {
                    this.availableItems.push({
                        id: element.idGeofence.toString(),
                        name: element.name,
                        val: element.idGeofence.toString()
                    });
                });
                this.availableItems.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));

                //si es ver o editar
                if (this.action === 'view' || this.action === 'ver' || this.action === 'edit' || this.action === 'editar' || this.action === 'update') {
                    if (this.model.userGeofenceViewList.length > 0) {
                        this.model.userGeofenceViewList.forEach(geoList => {
                            this.geofencesArray.forEach(geo => {
                                if (geo.idGeofence === geoList.idGeofence) {
                                    this.selectedItems.push({
                                        id: geo.idGeofence.toString(),
                                        name: geo.name,
                                        val: geo.idGeofence.toString()
                                    });
                                    this.currentSelectItems.push({
                                        value: geo.idGeofence.toString(),
                                        text: geo.name,
                                    });
                                }
                            });
                        });
                        this.selectedItems.forEach(selec => {
                            this.availableItems.forEach((avalible, index) => {
                                if (avalible.id === selec.id) {
                                    this.availableItems.splice(index, 1);
                                }
                            });
                        });
                    }

                }
            }, (error) => {
                console.error('error al cargar las geocercas', error);
            });
        }
        /** termina obtener lista de geocercas */
        // obtener lista de geocercas alerta
        if (this.action === 'add' || this.action === 'agregar') {
            this.searchAdvance.geofenceType = 2;
            this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                this.geofencesAlertArray = this.geofencesAlertArray.concat(geofences.content);
                this.availableItemsAlert = [];
                this.selectedItemsAlert = [];
                this.geofencesAlertArray.forEach((element) => {
                    this.availableItemsAlert.push({
                        id: element.idGeofence.toString(),
                        name: element.name,
                        val: element.idGeofence.toString()
                    });
                });
                this.availableItemsAlert.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));

                //si es ver o editar
                if (this.action === 'view' || this.action === 'ver' || this.action === 'edit' || this.action === 'editar' || this.action === 'update') {
                    if (this.model.userGeofenceAlertViewList.length > 0) {
                        this.model.userGeofenceAlertViewList.forEach(geoList => {
                            this.geofencesAlertArray.forEach(geo => {
                                if (geo.idGeofence === geoList.idGeofence) {
                                    this.selectedItemsAlert.push({
                                        id: geo.idGeofence.toString(),
                                        name: geo.name,
                                        val: geo.idGeofence.toString()
                                    });
                                    this.currentSelectItemsAlert.push({
                                        value: geo.idGeofence.toString(),
                                        text: geo.name,
                                    });
                                }
                            });
                        });
                        this.selectedItemsAlert.forEach(selec => {
                            this.availableItemsAlert.forEach((avalible, index) => {
                                if (avalible.id === selec.id) {
                                    this.availableItemsAlert.splice(index, 1);
                                }
                            });
                        });
                    }
                }
            }, (error) => {
                console.error('error al cargar las geocercas alerta', error);
            });
        }
        /**termina obtener lista de geocercas alerta*/

        //  /**obteniendo lista de usuarios*/
        // if ((this.action === 'add' || this.action === 'agregar' )){
        //     this.service.findByGroups().subscribe(users1 => {
        //         this.duallistUserList = users1.map(users => new DuallistboxOption(users.idUserApp.toString(), users.username , this.model.users.indexOf(users.idUserApp.toString()) > -1));
        //
        //     });
        //  }

        // $ (document).on('mouseover', "select", function () {
        //     $ (this).parent().find(".filter").blur ();
        //     });
        $(document).on('keyup', ".bootstrap-duallistbox-container .filter", function () {
            $(this).blur();
            $(this).focus();
        });
    }

    private crearFormVAlido() {
        if (this.model.profile == 134 || this.model.profile == 27 || this.model.profile == 30 || this.model.profile == 103) {
            this.FormValidacion =
                this.formBuilder.group({
                    username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                    password: [this.model.password, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                    email: [this.model.email.value, [Validators.email]],
                    numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                    userProfile: [this.model.profile, [Validators.required]],
                    turnoLaboral: [this.idWorkShift, [Validators.required]],
                    Sucursal: [this.model.extra1, [Validators.required, Validators.pattern('^[0-9]*$')]],
                    Cuadrilla: [this.model.extra2, [Validators.required,Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                    noVendedor: [this.model.extraConfiguration.nvm],
                    maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                    Tipo: [this.extraConfiguracion,[Validators.required]],
                    att: [this.tipoTecnologia,[Validators.required]],
                    AutoAssigne: [this.model.extra4],
                    Estatus: [this.model.status],
                    AutoAgendado: [this.model.extra5],
                    Dum: [this.model.extraConfiguration.dum.ne],
                    pagos: [this.model.extraConfiguration.pagos],
                    quiosco: [this.model.extraConfiguration.quiosco],
                    validarEquipo: [this.model.extraConfiguration.validarEquipo],
                    mdm: [this.model.extraConfiguration.mdm],
                    metrospre: [this.model.extraConfiguration.metrospre],
                    device: [this.model.extraConfiguration.device],
                    externa: [this.model.extraConfiguration.externa],
                    cuadlog: [this.model.extraConfiguration.cuadlog],
                    autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                    vtw: [this.model.extraConfiguration.vtw],
                    agendex: [this.model.extraConfiguration.agendex],
                    tmm: [this.model.extraConfiguration.tmm  ? this.model.extraConfiguration.tmm : 60],
                    ntm: [this.model.extraConfiguration.ntm],
                    dashProd: [this.model.extraConfiguration.dashProd],
                    bulk: [this.model.extraConfiguration.bulk],
                    priorizar: [this.model.extraConfiguration.priorizar],
                    editarPerfil: [this.model.extraConfiguration.editarPerfil],
                    user_dimme: [this.model.user_dimme],
                });
                
        } else if (this.model.profile == 34) {
            if(this.model.extraConfiguration.pagos==true){
                this.FormValidacion =
                this.formBuilder.group({
                    username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                    password: [this.model.password, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                    email: [this.model.email.value, [Validators.email]],
                    numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                    userProfile: [this.model.profile, [Validators.required]],
                    turnoLaboral: [this.idWorkShift, [Validators.required]],
                    Sucursal: [this.model.extra1, [Validators.required, Validators.pattern('^[0-9]*$')]],
                    Cuadrilla: [this.model.extra2,[Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                    noVendedor: [this.model.extraConfiguration.nvm, [Validators.required, Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
                    maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                    Tipo: [this.extraConfiguracion, [Validators.required]],
                    att: [this.tipoTecnologia,[Validators.required]],
                    AutoAssigne: [this.model.extra4],
                    Estatus: [this.model.status],
                    AutoAgendado: [this.model.extra5],
                    Dum: [this.model.extraConfiguration.dum.ne],
                    pagos: [this.model.extraConfiguration.pagos],
                    quiosco: [this.model.extraConfiguration.quiosco, [Validators.required]],
                    validarEquipo: [this.model.extraConfiguration.validarEquipo],
                    mdm: [this.model.extraConfiguration.mdm],
                    metrospre: [this.model.extraConfiguration.metrospre],
                    device: [this.model.extraConfiguration.device],
                    externa: [this.model.extraConfiguration.externa],
                    cuadlog: [this.model.extraConfiguration.cuadlog],
                    autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                    vtw: [this.model.extraConfiguration.vtw],
                    agendex: [this.model.extraConfiguration.agendex],
                    e2e: [this.model.extraConfiguration.e2e],
                    tmm: [this.model.extraConfiguration.tmm  ? this.model.extraConfiguration.tmm : 60],
                    ntm: [this.model.extraConfiguration.ntm],
                    dashProd: [this.model.extraConfiguration.dashProd],
                    bulk: [this.model.extraConfiguration.bulk],
                    priorizar: [this.model.extraConfiguration.priorizar],
                    editarPerfil: [this.model.extraConfiguration.editarPerfil],
                    user_dimme: [this.model.user_dimme],
                });
            }else{

                this.FormValidacion =
                this.formBuilder.group({
                    username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                    password: [this.model.password, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                    email: [this.model.email.value, [Validators.email]],
                    numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                    userProfile: [this.model.profile, [Validators.required]],
                    turnoLaboral: [this.idWorkShift, [Validators.required]],
                    Sucursal: [this.model.extra1, [Validators.required, Validators.pattern('^[0-9]*$')]],
                    Cuadrilla: [this.model.extra2,[Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                    noVendedor: [this.model.extraConfiguration.nvm, [Validators.required, Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
                    maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                    Tipo: [this.extraConfiguracion, [Validators.required]],
                    att: [this.tipoTecnologia,[Validators.required]],
                    AutoAssigne: [this.model.extra4],
                    Estatus: [this.model.status],
                    AutoAgendado: [this.model.extra5],
                    Dum: [this.model.extraConfiguration.dum.ne],
                    pagos: [this.model.extraConfiguration.pagos],
                    quiosco: [this.model.extraConfiguration.quiosco],
                    validarEquipo: [this.model.extraConfiguration.validarEquipo],
                    mdm: [this.model.extraConfiguration.mdm],
                    metrospre: [this.model.extraConfiguration.metrospre],
                    device: [this.model.extraConfiguration.device],
                    externa: [this.model.extraConfiguration.externa],
                    cuadlog: [this.model.extraConfiguration.cuadlog],
                    autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                    vtw: [this.model.extraConfiguration.vtw],
                    agendex: [this.model.extraConfiguration.agendex],
                    e2e: [this.model.extraConfiguration.e2e],
                    tmm: [this.model.extraConfiguration.tmm  ? this.model.extraConfiguration.tmm : 60],
                    ntm: [this.model.extraConfiguration.ntm],
                    dashProd: [this.model.extraConfiguration.dashProd],
                    bulk: [this.model.extraConfiguration.bulk],
                    priorizar: [this.model.extraConfiguration.priorizar],
                    editarPerfil: [this.model.extraConfiguration.editarPerfil],
                    user_dimme: [this.model.user_dimme],
                });
            }
        } else if (this.model.profile == 63 || this.model.profile == 64) {
            this.FormValidacion =
                this.formBuilder.group({
                    username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                    password: [this.model.password, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                    email: [this.model.email.value, [Validators.email]],
                    numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                    userProfile: [this.model.profile, [Validators.required]],
                    turnoLaboral: [this.idWorkShift, [Validators.required]],
                    Sucursal: [this.model.extra1, [Validators.required, Validators.pattern('^[0-9]*$')]],
                    Cuadrilla: [this.model.extra2, [Validators.required, Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                    noVendedor: [this.model.extraConfiguration.nvm, [Validators.required, Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
                    maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                    Tipo: [this.extraConfiguracion, [Validators.required]],
                    att: [this.tipoTecnologia,[Validators.required]],
                    AutoAssigne: [this.model.extra4],
                    Estatus: [this.model.status],
                    AutoAgendado: [this.model.extra5],
                    Dum: [this.model.extraConfiguration.dum.ne],
                    pagos: [this.model.extraConfiguration.pagos],
                    quiosco: [this.model.extraConfiguration.quiosco],
                    validarEquipo: [this.model.extraConfiguration.validarEquipo],
                    mdm: [this.model.extraConfiguration.mdm],
                    metrospre: [this.model.extraConfiguration.metrospre],
                    device: [this.model.extraConfiguration.device],
                    externa: [this.model.extraConfiguration.externa],
                    cuadlog: [this.model.extraConfiguration.cuadlog],
                    autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                    vtw: [this.model.extraConfiguration.vtw],
                    agendex: [this.model.extraConfiguration.agendex],
                    tmm: [this.model.extraConfiguration.tmm  ? this.model.extraConfiguration.tmm : 60],
                    ntm: [this.model.extraConfiguration.ntm],
                    dashProd: [this.model.extraConfiguration.dashProd],
                    bulk: [this.model.extraConfiguration.bulk],
                    priorizar: [this.model.extraConfiguration.priorizar],
                    editarPerfil: [this.model.extraConfiguration.editarPerfil],
                    user_dimme: [this.model.user_dimme],

                });

        } else {
            this.FormValidacion =
                this.formBuilder.group({
                    username: [this.model.userName, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-_=$]+$/)]],
                    password: [this.model.password, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    passwordConfirm: [this.model.passwordConfirm, [Validators.minLength(8),
                        Validators.maxLength(8),
                        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]+$')]],//Validators.required,
                    name: [this.model.name, [Validators.required, Validators.pattern(/^[a-zA-ZñÑ0-9\s]+$/)]],
                    email: [this.model.email.value, [Validators.email]],
                    numTel: [this.model.numTel, [Validators.minLength(10),Validators.maxLength(10), Validators.pattern('^[0-9]{10}$')]],
                    userProfile: [this.model.profile, [Validators.required]],
                    turnoLaboral: [this.idWorkShift, [Validators.required]],
                    Sucursal: [this.model.extra1],
                    Cuadrilla: [this.model.extra2, [Validators.pattern("^[a-zA-Z0-9]+\\-+[a-zA-Z0-9]*$")]],
                    noVendedor: [this.model.extraConfiguration.nvm],
                    maxTimeOnTicket: [this.model.extraConfiguration.tmad, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
                    Tipo: [this.extraConfiguracion],
                    att: [this.tipoTecnologia],
                    AutoAssigne: [this.model.extra4],
                    Estatus: [this.model.status],
                    AutoAgendado: [this.model.extra5],
                    Dum: [this.model.extraConfiguration.dum.ne],
                    pagos: [this.model.extraConfiguration.pagos],
                    quiosco: [this.model.extraConfiguration.quiosco],
                    validarEquipo: [this.model.extraConfiguration.validarEquipo],
                    mdm: [this.model.extraConfiguration.mdm],
                    metrospre: [this.model.extraConfiguration.metrospre],
                    device: [this.model.extraConfiguration.device],
                    externa: [this.model.extraConfiguration.externa],
                    cuadlog: [this.model.extraConfiguration.cuadlog],
                    autoasgeoale: [this.model.extraConfiguration.autoasgeoale],
                    vtw: [this.model.extraConfiguration.vtw],
                    agendex: [this.model.extraConfiguration.agendex],
                    e2e: [this.model.extraConfiguration.e2e],
                    tmm: [this.model.extraConfiguration.tmm  ? this.model.extraConfiguration.tmm : 60],
                    ntm: [this.model.extraConfiguration.ntm],
                    dashProd: [this.model.extraConfiguration.dashProd],
                    bulk: [this.model.extraConfiguration.e2e],
                    priorizar: [this.model.extraConfiguration.priorizar],
                    editarPerfil: [this.model.extraConfiguration.editarPerfil],
                    user_dimme: [this.model.user_dimme],
                });
                
        }


        // if (this.model.profile != 34){
        //     this.FormValidacion =
        //         this.formBuilder.group({
        //             username: [this.model.userName, [Validators.required]],
        //             password: [[Validators.minLength(6)]],
        //             passwordConfirm: [[Validators.minLength(6)]],
        //             name: [this.model.name, [Validators.required]],
        //             email: [this.model.email.value, [Validators.required, Validators.email]],
        //             userProfile: [this.model.profile, [Validators.required]],
        //             turnoLaboral: [this.idWorkShift, [Validators.required]],
        //             Sucursal: [this.model.extra1],
        //             Cuadrilla: [this.model.extra2, [Validators.pattern("^[a-zA-Z]+\-+([0-9])*$")]],
        //             noVendedor: [this.model.extra2],
        //             Tipo: [this.extraConfiguracion],
        //             AutoAssigne: [this.model.extra4],
        //             Estatus: [this.model.status],
        //             AutoAgendado: [this.model.extra5],
        //             Dum:[this.model.extraConfiguration.dum.ne]
        //         });
        // }else{
        //     this.FormValidacion =
        //         this.formBuilder.group({
        //             username: [this.model.userName, [Validators.required]],
        //             password: [[Validators.minLength(6)]],
        //             passwordConfirm: [[Validators.minLength(6)]],
        //             name: [this.model.name, [Validators.required]],
        //             email: [this.model.email.value, [Validators.required, Validators.email]],
        //             userProfile: [this.model.profile, [Validators.required]],
        //             turnoLaboral: [this.idWorkShift, [Validators.required]],
        //             Sucursal: [this.model.extra1],
        //             Cuadrilla: [this.model.extra2],
        //             noVendedor: [this.model.extra2, [Validators.required, Validators.min(1), Validators.maxLength(25), Validators.pattern('^[0-9]*$')]],
        //             Tipo: [this.extraConfiguracion],
        //             AutoAssigne: [this.model.extra4],
        //             Estatus: [this.model.status],
        //             AutoAgendado: [this.model.extra5],
        //             Dum:[this.model.extraConfiguration.dum.ne]
        //         });
        // }

    }

        /**
 * Verifica si un perfil gestor puede gestionar a un usuario concreto.
 * @param {number} idGestor - ID del perfil del gestor (ej. 146).
 * @param {number} idGestionado - ID del perfil a gestionar (ej. 130).
 * @param {number} idUsuarioGestionado - ID del usuario concreto a gestionar (idUserApp).
 * @param {number[]} [asignadosGestor=[]] - Lista de IDs de usuarios que el gestor tiene asignados.
 * @returns {boolean}
 * 
 */
    validateCanEditByProfile() {
        if(this.fromHeader) return;

        this.infoUserLogged = JSON.parse(localStorage.getItem('info_user_logged') || '{}');

        const {
            profileId = null,
            projectionViewInScheduleView = []
        } = this.infoUserLogged.userAppView || {};

        const hasManagementProfile = UsersGestionByProfile.some(
            p => p.idGestor === profileId
        );

        if (!hasManagementProfile) return;

        this.isSpecialProfileManagement = true;

        const canManagement = this.canManagementAllActions(
            profileId,
            this.model.profile,
            this.id,
            projectionViewInScheduleView
        );
        if (this.id == this.infoUserLogged.userAppView.idUserApp) {
            this.readonly = true;
            this.canUpdateByProfile = true;
            this.forcePasswordAndStatusManagmenet = true;
            return;
        }
        const isAssignedUser = projectionViewInScheduleView.some(
            (x: any) => x.idUserApp === this.id
        );

        this.readonly = true;

        if (canManagement.can) {
            if (canManagement.all || isAssignedUser) {
                this.forcePasswordAndStatusManagmenet = true;
            } else {
                this.canUpdateByProfile = false;
            }
        } else {
            this.canUpdateByProfile = false;
        }

        setTimeout(() => {
            const invalidEmail = !this.model.email || this.model.email.value === '';
            const invalidPhone = !this.model.numTel || this.model.numTel === '';

            if (invalidEmail && invalidPhone) {
                this.dialogCantEdit();
            }
        }, 600);
    }

    canManagementAllActions(
        idGestor,
        idGestionado,
        idUsuarioGestionado,
        asignadosGestor = []
    ): { can: boolean, all: boolean } {

        const reglasGestor = UsersGestionByProfile.filter(
            p => p.idGestor === idGestor
        );

        // No existe ninguna regla → acceso total
        if (!reglasGestor.length) {
            return { can: true, all: true };
        }

        const regla = reglasGestor.find(
            p => p.idGestionado === idGestionado
        );

        // Existe gestor pero no tiene permiso para ese perfil
        if (!regla) {
            return { can: false, all: false };
        }

        // Acceso total
        if (regla.accesoTotal) {
            return { can: true, all: true };
        }

        // Acceso restringido
        const isAssigned = asignadosGestor.some(
            (x: any) => x.idUserApp === idUsuarioGestionado
        );

        return {
            can: isAssigned,
            all: false
        };
    }
    

    dialogCantEdit() {
        this.notifications.bigBox({
            title: 'No puedes editar el usuario',
            content: 'El usuario no cuenta con correo o teléfono, solicita la actualización con admin de mantenimiento.',
            color: "#C46A69",
            icon: "fa fa-warning shake animated",
            timeout: 6000
        });
    }

onItemsMoved(event): void {
    const maxGeofences = this.model.extraConfiguration.autoasgeoale ? 1 : 4;

    // Acción de agregar (from 'available' to 'selected')
    if (event.from === 'available' && event.to === 'selected') {
        if (event.selected.length > maxGeofences) {
            // Revertir: obtener el elemento movido
            const movedItem = event.movedItems[0];
            if (movedItem) {
                // 1. Quitarlo de selectedItems
                const index = this.selectedItems.findIndex(item => item.id === movedItem.value);
                if (index > -1) {
                    this.selectedItems.splice(index, 1);
                }
                // 2. Regresarlo a availableItems
                this.availableItems.push({
                    id: movedItem.value,
                    name: movedItem.text,
                    val: movedItem.value
                });
                // 3. Forzar actualización de referencias para que el dual-list detecte el cambio
                this.selectedItems = [...this.selectedItems];
                this.availableItems = [...this.availableItems].sort((a, b) => 
                    a.name.localeCompare(b.name)
                );
                // 4. Actualizar currentSelectItems con el array revertido
                this.currentSelectItems = this.selectedItems.map(item => ({
                    value: item.id,
                    text: item.name
                }));
            }
            // Mostrar mensaje de límite
            // this.createNotification('warning', 'Error en el formulario', 
            //     `Solo puedes tener ${maxGeofences} Geocerca(s) como máximo asignada(s)`);
            // return; // No continuar
        }
    }

    // Para cualquier otro caso (quitar, reordenar, etc.) actualizar normalmente
    this.currentSelectItems = event.selected;
}

    showLabelOnlyOneGeo(): boolean{
        const hasAutoasgeoale = this.model.extraConfiguration.autoasgeoale;
        if (hasAutoasgeoale && this.currentSelectItems.length > 1) return true;
        else return false;
    }

    showLabelLimitGeo(): boolean{
        const hasAutoasgeoale = this.model.extraConfiguration.autoasgeoale;
        if (!hasAutoasgeoale && this.currentSelectItems.length > 4) return true
        else return false;
    }

    showMessageOnlyOneGeo():void{
        this.notifications.bigBox(
            {
                title: 'No se puede agregar',
                content: 'Solo se puede agregar una geocerca.',
                color: "#C46A69",
                icon: "fa fa-warning shake animated",
                timeout: 6000
            }
        );
    }

    onItemsMovedGeoAlert(event): void {
        this.currentSelectItemsAlert = event.selected;
    }

    /**
     * Despues de cargar la vista (ngAfterViewInit) se asignan disparadores de evento
     *
     * Se asigna change a los elementos select con plugin select2.
     * Al disprarse el evento change se recupera el valor desde el plugin y se asigna a la variable del
     * componente indicado con el atributo ng-Model en el elemento select.
     * Se manda llamar la funcion getTreeProfile para dibujar el arbol de permisos, suponiendo que el select
     * que disparo el evento change es el de perfiles.
     *
     * Se asignan keyup, change, input, paste, cut a los elementos tipo email para validar el email del mismo.
     */
    createNotification(type: string, title?: string, content?: string): void {
        this.notification.config({
            nzPlacement: 'bottomRight'
        });
        this.notification.create(
            type,
            title,
            content,
            {nzAnimate: true}
        );
    }

    private listaGeocercas: boolean = true;
    private listaGeocercasAlert: boolean = true;

    ngAfterViewInit() {
        $('select').on('change', () => {
                this.getTreeProfile();
        });
        $('select[select2]').on('change', (ev) => {
            let elSelect = ev.target;
            if ($(elSelect).attr('ng-Model')) {
                let properties = $(elSelect).attr('ng-Model').split('.');
                let lastProp = properties.pop();
                let varToSave = this;
                properties.forEach((prop) => {
                    varToSave = varToSave[prop];
                });
                varToSave[lastProp] = !!$(elSelect).val() ? $(elSelect).val() : [];
            }
        });
        $('input[type=email]').on('keyup change input paste cut', (ev) => {
            let element = ev.target;
            this.model[element.getAttribute('name')].valid = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test($(element).val());
        });
        //    agregado por gloria para escuchar el scroll
        this.chatControl.element = document.getElementById('comments-container-usuarios');
        this.chatControl.previousScrollTop = this.chatControl.element.scrollTop;
        this.chatControl.element.onscroll = () => this.chatScrollByUser();
        setInterval(() => this.chatScrollToBottom(), 500);
        this.addScrollListener();

        this.escuchadorImputGeo();

        this.listenInputGeoAlert();

        let trees = document.querySelectorAll('.tree');
        let c = 1;
        trees.forEach((elemento) => {
            elemento.classList.add(`tree${c}`);
            c++;
        });

        let fondo = document.querySelector('.modal-backdrop');
        fondo.classList.add('fondoZindexModalCrearUsuarios');
        setTimeout(() => {
            let fondo2 = document.querySelector('.new-user-dialog');
            fondo2.classList.add('fondoZindexModalCrearUsuarios');
        }, 1000);
    }

    private geoBusqueda: any;
    private geoAlertBusqueda: any;
    private geoSelectTemp: any = [];
    private geoAlertSelectTemp: any = [];
    private geoCurrentTemp: any = [];
    private geoAlertCurrentTemp: any = [];

    private escuchadorImputGeo() {
        setTimeout(() => {
            //    agregar escuchador para la busqueda de geocercas
            $('#availableSearchInput').on('keyup', (event) => {
                if (event.originalEvent.key === 'Enter') {
                    // this.geoSelectTemp = this.currentSelectItems;
                    //llenar los listados antes de ser borrados
                    this.geoSelectTemp = [];
                    this.geoCurrentTemp = [];
                    this.currentSelectItems.forEach(geoList => {
                        this.geoCurrentTemp.push({
                            value: geoList.value,
                            text: geoList.text,
                        });
                        this.geoSelectTemp.push({
                            id: geoList.value,
                            name: geoList.text,
                            val: geoList.value
                        });
                    });


                    this.listaGeocercas = false;
                    this.searchAdvance.search = event.target.value;
                    this.geoBusqueda = event.target.value;

                    //obtener lista de geocercas
                    this.searchAdvance.geofenceType = 1;
                    this.searchAdvance.idTypeTicket = this.extraConfiguracion;
                    this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                        this.geofencesArray = this.geofencesArray.concat(geofences.content);

                        this.availableItems = [];
                        // this.selectedItems = [];
                        this.listaGeocercas = true;
                        //cargar busqueda previa y lista de seleccionados previa
                        setTimeout(() => {
                            $('#availableSearchInput').val(this.geoBusqueda);
                            this.selectedItems = this.geoSelectTemp;
                            this.currentSelectItems = this.geoCurrentTemp;
                        }, 50);

                        geofences.content.forEach((element) => {
                            this.availableItems.push({
                                id: element.idGeofence.toString(),
                                name: element.name,
                                val: element.idGeofence.toString()
                            });
                        });
                        //quita las geocercas seleccionadas de la busqueda en el input
                        this.selectedItems.forEach(selec => {
                            this.availableItems.forEach((avalible, index) => {
                                if (avalible.id === selec.id) {
                                    this.availableItems.splice(index, 1);
                                }
                            });
                        });

                        this.availableItems.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));
                        // inicio de segundo escuchador
                        this.escuchadorImputGeo();
                        //finaliza el segundo escuchador no se paraque chingados
                    }, (error) => {
                        console.error('error al cargar las geocercas', error);
                        setTimeout(() => {
                            $('#availableSearchInput').val(this.geoBusqueda);
                        }, 50);
                    });
                    /**termina obtener lista de geocercas*/
                }
            });
        }, 500);
    }

    listenInputGeoAlert() {
        setTimeout(() => {
            //    agregar escuchador para la busqueda de geocercas alerta
            $('#dualListGeoAlert #availableSearchInput').on('keyup', (event) => {
                if (event.originalEvent.key === 'Enter') {
                    // this.geoSelectTemp = this.currentSelectItems;
                    //llenar los listados antes de ser borrados
                    this.geoAlertSelectTemp = [];
                    this.geoAlertCurrentTemp = [];
                    this.currentSelectItemsAlert.forEach(geoList => {
                        this.geoAlertCurrentTemp.push({
                            value: geoList.value,
                            text: geoList.text,
                        });
                        this.geoAlertSelectTemp.push({
                            id: geoList.value,
                            name: geoList.text,
                            val: geoList.value
                        });
                    });


                    this.listaGeocercasAlert = false;
                    this.searchAdvance.search = event.target.value;
                    this.geoAlertBusqueda = event.target.value;

                    //obtener lista de geocercas
                    this.searchAdvance.geofenceType = 2;
                    this.geofencesService.getPage(this.searchAdvance).subscribe(geofences => {
                        this.geofencesAlertArray = this.geofencesAlertArray.concat(geofences.content);

                        this.availableItemsAlert = [];
                        // this.selectedItems = [];

                        //cargar busqueda previa y lista de seleccionados previa
                        setTimeout(() => {
                            this.selectedItemsAlert = this.geoAlertSelectTemp;
                            this.currentSelectItemsAlert = this.geoAlertCurrentTemp;
                        geofences.content.forEach((element) => {
                            this.availableItemsAlert.push({
                                id: element.idGeofence.toString(),
                                name: element.name,
                                val: element.idGeofence.toString()
                            });
                        });
                        // quita las geocercas seleccionadas de la busqueda en el input
                        this.selectedItemsAlert.forEach(selec => {
                            this.availableItemsAlert.forEach((avalible, index) => {
                                if (avalible.id === selec.id) {
                                    this.availableItemsAlert.splice(index, 1);
                                }
                            });
                        });

                        this.availableItemsAlert.sort((o1, o2) => Intl.Collator().compare(o1.name.toLowerCase(), o2.name.toLowerCase()));
                        this.listaGeocercasAlert = true;
                            setTimeout(() => {
                                $('#dualListGeoAlert #availableSearchInput').val(this.geoAlertBusqueda);
                            }, 50);
                        }, 50);
                        // inicio de segundo escuchador
                        this.listenInputGeoAlert();
                        // finaliza el segundo escuchador no se paraque chingados
                    }, (error) => {
                        console.error('error al cargar las geocercas alertas', error);
                        setTimeout(() => {
                            $('#dualListGeoAlert #availableSearchInput').val(this.geoAlertBusqueda);
                        }, 50);
                    });
                    /**termina obtener lista de geocercas alertas*/
                }
            });
        }, 500);
    }

    private scrolActual: any;

    private addScrollListener() {
        const contInitForm: Element = document.getElementById('contPrincipalUser');
        contInitForm.addEventListener('scroll', (event: any) => {
            this.scrolActual = event.target.scrollTo;
            this.tabs.forEach((tab) => tab.active = false);
            //si el usuario es de tipo agente no tiene que tener lista de usuarios
            if ((this.model.profile === 134 ||this.model.profile === 27 || this.model.profile === 93 || this.model.profile === 30 || this.model.profile == 63 || this.model.profile == 64 || this.model.profile == 34 || this.model.profile == 88 || this.model.profile == 92 || this.model.profile == 130 || this.model.profile == 103)) {
                if (event.target.scrollTop >= 0 && event.target.scrollTop < 709) {
                    this.tabs[0].active = true;
                }
                if (event.target.scrollTop >= 710 && event.target.scrollTop < 1020) {
                    this.tabs[1].active = true;
                }
                if (event.target.scrollTop >= 1021 && event.target.scrollTop < 1297) {
                    this.tabs[2].active = true;
                }
                if (event.target.scrollTop >= 1298) {
                    this.tabs[3].active = true;
                }
            } else {
                //verifica si tiene lista de usuarios
                if (this.duallistUserList.length != 0) {
                    this.tamDualis = 225;
                } else {
                    this.tamDualis = 0;
                }
                if (event.target.scrollTop >= 0 && event.target.scrollTop < 709) {
                    this.tabs[0].active = true;
                }
                if (event.target.scrollTop > 710 && event.target.scrollTop < 1020) {
                    this.tabs[1].active = true;
                }
                if (event.target.scrollTop > 1021 && event.target.scrollTop < (1200 + this.tamDualis)) {
                    this.tabs[2].active = true;
                }
                if (event.target.scrollTop > (1201 + this.tamDualis) && event.target.scrollTop < (1480 + this.tamDualis)) {
                    this.tabs[3].active = true;
                }
                if (event.target.scrollTop > (1481 + this.tamDualis)) {
                    this.tabs[4].active = true;
                }
            }
        });
    }

    private checkScrollViews(event): void {
        let maxScroll: number = (event.target as HTMLInputElement).scrollHeight - (event.target as HTMLInputElement).clientHeight;
        let cincoPorciento = (5 * maxScroll) / 100;
        maxScroll = maxScroll - cincoPorciento;
        let currentScroll: number = (event.target as HTMLInputElement).scrollTop;
        if (currentScroll >= maxScroll) {
            this.newMaxScroll = maxScroll;
            // this.loadMoreUsers(false);
        }
    }

    chatScrollByUser() {
        this.chatControl.scrolledByUser = this.chatControl.element.scrollHeight - this.chatControl.element.scrollTop !== this.chatControl.element.clientHeight;
    }

    chatScrollToBottom() {
        if (!this.chatControl.scrolledByUser) {
            if (this.chatControl.previousScrollTop !== this.chatControl.element.scrollHeight - this.chatControl.element.clientHeight) {
                this.chatControl.element.scrollTop = this.chatControl.element.scrollHeight - this.chatControl.element.clientHeight;
                this.chatControl.previousScrollTop = this.chatControl.element.scrollTop;
            }
        }
    }

    /* Funciones para arbol de permisos */
    /**
     * Se revisa si se selecciono algun perfil, y si este es la primera vez que se selecciona o es
     * diferente al anterior se manda llamar al arbol de permisos relacionado con este perfil para
     * dibujarlo, en un inicio el arbol de permisos se oculta.
     * Se manda llamar la funcion readonlyTree si la accion detectada es la de ver el usuario registrado.
     */
    getTreeProfile() {
        if (!!this.model.profile && this.model.previousProfile != this.model.profile) {
            let permissions = this.model.permissionsList;
            this.model.previousProfile = this.model.profile;
            this.profileService.get(this.model.profile).subscribe(success => {
                success.tree.forEach((element: any) => {
                    if (element.content == 'Usuarios') {
                        element.children = element.children.filter((x: any) => {
                            return (x.content != 'Validar dispositivo' && x.content != 'Validar llave de seguridad')
                        })
                    }
                });
                success.tree = success.tree;
                
                this.model.profileTree = success.tree;
                    if (this.infoUserLogged.userAppView.profileId !== 1) {
                        this.model.profileTree.forEach(item => {
                            if (item.id === 105 && item.children) {
                                let disableParent = false;
                                item.children.forEach(child => {
                                    if (child.content === 'Denegar Acceso Web') {
                                        child.disabled = true;
                                        disableParent = true;
                                    }
                                });
                                if (disableParent) {
                                    item.disabled = true;
                                }
                            }
                        });
                    }
                
                this.model.permissionsList = [];
                if (permissions.length > 0)
                    this.activeCustomPermissions(this.model.profileTree, permissions);
                if (this.readonly)
                    this.readonlyTree(this.model.profileTree);

                function checkIfPermission(branch) {
                    return branch.active || !!(!!branch.children && !!branch.children.find(checkIfPermission));
                }

                this.hasPermissionSelected = !!this.model.permissionsList.find(checkIfPermission);
            });
        } else if (!this.model.profile) {
            this.model.profileTree = [];
        }
    }

    /**
     * Activa o desactiva los permisos del perfil basado en la seleccion personalizada de permisos
     * @param node
     *      modulo o grupo de permisos que se revisa
     * @param permissionsList
     *      Array de permisos personalizados
     */
    activeCustomPermissions(node, permissionsList) {
        let component = this;
        node.forEach(function (branch) {
            if (!!branch.children && branch.children.length > 0) {
                component.activeCustomPermissions(branch.children, permissionsList);
                return;
            }
            branch.active = !!permissionsList.find((permission) => branch.id == permission);
        });

        //El permiso hijo con el id 173 es el ultimo del arbol,
       //por lo tanto aqui termina el ciclo de la funcion activeCustomPermissions();
        if(node[0].id == 173){
          //Ya terminamos de barrer los permisos hijos, ahora barremos los permisos padre
          this.activeCustomPermissionsFather(this.model.profileTree);
        }
    }

    //Funcion que activa en True los check de los permisos padre
    activeCustomPermissionsFather( profileTree ){
       for(let padre = 0; padre < profileTree.length; padre = padre + 1){
          let contentidoPadre = profileTree[padre];
          if(!!contentidoPadre.children && contentidoPadre.children.length > 0){
             for(let hijo = 0; hijo < contentidoPadre.children.length; hijo = hijo + 1){
                let contenidoHijo = contentidoPadre.children[hijo];
                if(contenidoHijo.active == true){
                   contentidoPadre.active = true;
                }else if(contenidoHijo.active == false){
                   contentidoPadre.active = false;
                   hijo = contentidoPadre.children.length;
                }
              }
           }
        }
     }

    /**
     * Se asigna la propiedad readonly a true, para que se desabiliten los checkbox siendo de solo lectura.
     * Funcion recursiva
     * @param node
     *      modulo o grupo de permisos al que se le asigna readonly
     */
    readonlyTree(node) {
        let component = this;
        node.forEach(function (branch) {
            branch.readonly = true;
            if (branch.children && !!branch.children.length)
                component.readonlyTree(branch.children);
        });
    }

    /**
     * Muestra u oculta el árbol de permisos con un efecto de slide
     */
    toggleTree() {
        $('#showPermissions').slideToggle('fast');
    }

    /**
     * Se revisa si hay permisos seleccionados, true si almenos uno o false si ninguno
     */
    permissionSeleted() {
        this.hasPermissionSelected = !!$('.tree2').find('input:checkbox[permission]:checked').length;
    }

    permissionSeleted2(event) {
        if (event != undefined) {
            let gruposId = [];
            $('.tree1').find('input:checkbox[permission]:checked').each(function () {
                gruposId.push(+this.value);
            });
            this.byprofile.idGroups = gruposId;
            this.model.groups = gruposId;
            this.getSubgroups(this.byprofile.idGroups);
        }
    }

    onKey(event) {
        let values = event.target.value;
        let regExp = /^[a-zA-Z]+\-+([0-9])*$/;
        // this.bandExpRegCuadrilla = !(regExp.test(values) || values == '');
    }

    onKeyNumber(event) {
        let values = event.target.value;
        let regExp = /^([0-9])*$/;
        // this.bandExpRegCuadrilla = !(regExp.test(values) || values == '');
    }

    onKey2(event) {
        let expr = new RegExp(event.target.value.toLowerCase());
        this.availableItems = this.availableItems.filter((element) => {
            if (expr.test(element.name.toLowerCase())) {
                return true;
            }
        });
    }

    onKeyDum(event: KeyboardEvent) {
        let value = (<HTMLInputElement>event.target).value;
        if (event.target) {
            if (value == "") {
                value = value.slice(0, 0);
            }
            (<HTMLInputElement>event.target).value = value.replace(/\D/g, '');
        }
    }

    onKeyDumNumTel(event: KeyboardEvent) {
        let value = (<HTMLInputElement>event.target).value;
        
        if (event.target) {
            if (value == "" ) {
                value = value.slice(0, 0);
            }
            (<HTMLInputElement>event.target).value = value.replace(/\D/g, '');
        }
    }
    numberValidate(event:any){
        const key = event;   
        console.log(key);
             
        if((String(this.model.numTel).length >= 10 || key.data == "e" || key.data == "." || key.data == "E") 
         && key.inputType != "deleteContentBackward" && key.inputType != "deleteContentForward"){            
            event.preventDefault();
        }
    }

    /* ~ */

    /* Funciones para informacion extra */
    /**
     * Se valida que se tengan llenos o vacios, tanto el key como el value; de lo contrario manda error.
     * Agrega nueva información extra al arreglo, se extiende el objeto agregando la propiedad updating
     * para controlar la edición. Y se limpian los datos del model.extraInfo
     */
    addExtraInfo() {
        if (!!this.model.extraInfo.key === !!this.model.extraInfo.value) {
            if (!!this.model.extraInfo.key) {
                this.model.extraInfo.error = false;
                this.extraInfo.push($.extend(this.model.extraInfo, {
                    userExtraInfoId: null,
                    updating: false
                }));
                this.model.extraInfo = {key: '', value: '', error: false};
            }
        } else {
            this.model.extraInfo.error = true;
        }
    }

    /**
     * Se valida y actualiza la información extra que esta siendo editada y/o se activa la edición del bloque deseado.
     * @param index
     *      index en el arreglo de información extra a ser guardada o para activar la edición.
     */
    updateExtraInfo(index?: number) {
        let indexEditing: number;
        let currentEditing = this.extraInfo.find((info, index) => {
            indexEditing = index;
            return info !== null && info.updating;
        });
        if (!!currentEditing) {
            if (currentEditing.key === '' || currentEditing.value === '') {
                currentEditing.error = true;
                return;
            } else {
                currentEditing.error = false;
                currentEditing.updating = false;
            }
        } else
            indexEditing = undefined;
        if (index !== undefined && index !== indexEditing)
            this.extraInfo[index].updating = !this.extraInfo[index].updating;
    }

    getGeofences() {
        let contador = 1;
        this.usersGeofenceList = [];
        this.currentSelectItems.forEach((geo) => {

            if (contador < 7) {//|| this.model.profile == 26
                this.usersGeofenceList.push({
                    idGeofence: +geo.value,
                    geofenceName: geo.text,
                    priorityGeofence: contador
                });
            }
            contador++;
        });
    }
    getGeofencesAlert () {
        this.usersGeofenceAlertList = [];
        this.currentSelectItemsAlert.forEach((geo) => {
                this.usersGeofenceAlertList.push({
                    idUserApp: this.id,
                    idGeofence: +geo.value,
                    geofenceName: geo.text,
                });
        });
    }

    /* ~ */
    Cancel() {
        this.bsModalRef.hide();
        this.onClose.next(true);
    }

    cargarErrores(): void {
        this.Errors = [];
        Object.keys(this.FormValidacion.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.FormValidacion.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    const nuevo = new ListaErrorsForms(key.toString(), keyError.toString());
                    switch (nuevo.controlName) {
                        case 'username' :
                            nuevo.nombreReal = 'Nombre de Usuario';
                            break;
                        case 'password' :
                            nuevo.nombreReal = 'Contraseña';
                            break;
                        case 'passwordConfirm' :
                            nuevo.nombreReal = 'Confirmar contraseña';
                            break;
                        case 'name' :
                            nuevo.nombreReal = 'Nombre';
                            break;
                        case 'email' :
                            nuevo.nombreReal = 'Correo eléctronico';
                            break;
                        case 'userProfile' :
                            nuevo.nombreReal = 'Perfil de usuario';
                            break;
                        case 'turnoLaboral' :
                            nuevo.nombreReal = 'Turno Laboral';
                            break;
                        case 'AutoAssigne' :
                            nuevo.nombreReal = 'Auto-asignación';
                            break;
                        case 'AutoAgendado' :
                            nuevo.nombreReal = 'Auto-agendado';
                            break;
                        case 'noVendedor' :
                            nuevo.nombreReal = 'Número de vendedor';
                            break;
                        case 'maxTimeOnTicket':
                            nuevo.nombreReal = 'Tiempo máximo para alerta en domicilio';
                            break;
                        case 'numTel':
                            nuevo.nombreReal = 'Teléfono';
                            break;
                    }
                    this.Errors.push(nuevo);
                });
            }
        });

        // //validar si es agente ventas llene el campo de no de vendedor
        // this.noVendedorValido = false;
        // if (this.model.profile == 34){
        //     if (this.model.extra2 != null){
        //         this.noVendedorValido = true;
        //     }else{
        //         this.noVendedorValido = false;
        //     }
        // }else{
        //     this.noVendedorValido = true;
        // }

    }

    private noVendedorValido: boolean = false;
    quioscoSeleccionado:any;
    Save(forma: NgForm) {

        const reglasGestor = UsersGestionByProfile.filter(
            p => p.idGestor === this.infoUserLogged.userAppView.profileId
        );
        const regla = reglasGestor.find(
            p => p.idGestionado === this.model.profile,
        );

        const invalidEmail = !this.model.email || this.model.email.value === '';
        const invalidPhone = !this.model.numTel || this.model.numTel === '';

        if (reglasGestor.length && regla && (invalidEmail && invalidPhone) && !this.fromHeader) {
            this.dialogCantEdit();
            return;
        }
        
        if (!this.noValidateEmployeeNumber && this.model.user_dimme && !this.userDimmeValidado && !(([26, 35, 106].includes(this.idProfileLogged) && this.viewProfile) || this.hideGeneralInfo) && this.model.profile != 1) {
            this.createNotification('warning', 'Error en el formulario', `Es necesario validar el número de empleado.`);
            return;
        }
        // let errorLengthGeos: boolean = false;
        // const hasAutoasgeoale = this.model.extraConfiguration.autoasgeoale;
        // if (!hasAutoasgeoale && this.currentSelectItems.length > 4) {
        //     errorLengthGeos = true;
        // }
        // if (hasAutoasgeoale && this.currentSelectItems.length > 1) {
        //     errorLengthGeos = true;
        // }
        //Transformando la data en tipo Tecnologia de string a numerico
        if (this.FormValidacion.controls.att.value == "Todos") {
            this.FormValidacion.controls.att.reset(0);
        }
        if (this.FormValidacion.controls.att.value == "Coaxial") {
            this.FormValidacion.controls.att.reset(1);
        }
        if (this.FormValidacion.controls.att.value == "Fibra") {
            this.FormValidacion.controls.att.reset(2);
        }
        //***********************************************************

        // console.log ('antes de enviar:', this.model);
        // console.log ('form activo:', this.FormValidacion);
        // console.log ('form valido? :', this.FormValidacion.valid);
        this.crearFormVAlido();
        this.cargarErrores();
        // this.getGeofences();
        // if (this.action == 'add' || this.action == 'agregar') {
        //     if (this.idWorkShift > 0){
        //         this.banworkshif = true;
        //     }
        // }else this.banworkshif = true;
        //Se obtiene arreglo de ID de permisos
        let validarCheckPresionado = [];
        $('.tree2').find('input:checkbox[permission]:checked').each(function () {
            validarCheckPresionado.push(+this.value);
        });

        if (this.action == 'update' || this.action == 'edit') {
            this.passwordRequerido = false;
            if (this.model.password && this.model.passwordConfirm) {
                if (this.model.password != this.model.passwordConfirm) {
                    this.passwordsIguales = true;
                } else {
                    this.passwordsIguales = false;
                }
            } else if ((this.model.password && !this.model.passwordConfirm) || (!this.model.password && this.model.passwordConfirm)) {
                this.passwordsIguales = true;
            } else {
                this.passwordsIguales = false;
            }

        } else {
            this.passwordsIguales = false;
            this.passwordRequerido = false;
            if (this.model.password != this.model.passwordConfirm) {
                this.passwordsIguales = true;
            }
        }

        //PARA CIERTAS CUADRILLAS NO DEJAR CONFIGURAR MAS DE UNA SUCURSAL
        let hasMoreGroups: boolean = false;
        let groupsSelected = [];
        let branchesMessage: string = 'No es posible configurar más de una sucursal';
        if ([27, 63, 64].includes(Number(this.model.profile))) {
            this.model.groups.forEach((groupId) => {
                let groupFind = this.gruposObject.find((group) => group.idSucursalHija == groupId);
                if (groupFind) {
                    groupsSelected.push(groupFind);
                    branchesMessage = branchesMessage + ', ' + groupFind.nameSucursalHija;
                }
            });
            const firstPart = branchesMessage.split(",")[0];
            const secondPart = branchesMessage.substring(firstPart.length);

            if (groupsSelected.length >= 2) {
                this.createNotification('warning', 'Error en el formulario', `${firstPart} (${groupsSelected.length})${secondPart}.`);
                return;
            }
        }
        if (this.model.profile == 96 || this.model.profile == 97 || this.model.profile == 164) {

            this.model.groups.forEach((groupId) => {
                let groupFind = this.gruposObject.find((group) => group.idSucursalHija == groupId);
                if (groupFind) {
                    groupsSelected.push(groupFind);
                }
            });
            hasMoreGroups = groupsSelected.every((group) => group.idSucursalPadre == groupsSelected[0].idSucursalPadre);

        } else {
            hasMoreGroups = true;
        }

        if (
            this.FormValidacion.valid &&
            this.model.groups.length != 0 &&
            this.model.profile != 0 &&
            this.idWorkShift != 0 &&
            this.passwordsIguales == false &&
            // !errorLengthGeos &&
            validarCheckPresionado.length != 0 &&
            this.passwordRequerido == false &&
            hasMoreGroups && (/\s/.test(this.model.userName) == false)
        ) {
            console.log("aquivalid");

            // let banderaAgente = false;
            //
            // if (this.model.profile == 27 || this.model.profile == 30 || this.model.profile == 63 || this.model.profile == 64 || this.model.profile == 34) {
            //     if (this.model.extra1.length > 0 && (this.model.extra2.length > 0 || this.model.extra2 > 0) && this.extraConfiguracion != null)
            //         banderaAgente = true;
            //     else
            //         banderaAgente = false;
            // } else {
            //     banderaAgente = true;
            // }
            let user: User = new User;
            // user.idUsersAssigned = this.usersHerarchyList;
            user.userGeofenceViewList = this.usersGeofenceList;
            user.userGeofenceAlertViewList = this.usersGeofenceAlertList;
            user.profileId = +this.model.profile;

            //Se obtiene arreglo de ID de permisos
            $('.tree2').find('input:checkbox[permission]:checked').each(function () {
                user.permissionsList.push(+this.value);
            });
            this.model.groups.forEach((group) => user.groupList.push(+group));
            /**capturar y mandar los datos de los usuarios*/
            // if ((this.action === 'update' || this.action === 'edit' || this.action === 'editar')) {
            this.duallistUserList.forEach(u => {
                if (u.selected) {
                    user.viewInScheduleViewList.push({
                        idToViewInSchedule: +u.key,
                        userNameToViewInSchedule: u.value
                    });
                }
            });
            /** Se obtienen las geocercas seleccionadas*/
            if (this.currentSelectItems.length) {
                this.getGeofences();
            }
            /** Se obtienen las geocercas alertas seleccionadas*/
            if (this.currentSelectItemsAlert.length) {
                this.getGeofencesAlert();
            }

            this.formSubmitted = true;
            if (this.model.realUserName !== '')
                this.model.userName = this.model.realUserName;
            //Se fuerza evento de keyup en los email para su validación.
            if (this.model.email) {
                $('input[type=email]').triggerHandler('keyup');
            }

            //Se fuerza la actualizacion y adición de la información extra para validación y guardado.
            this.updateExtraInfo();
            this.addExtraInfo();
            //Se optiene la información extra guardada, que no haya sido eliminada (null)
            this.extraInfo = this.extraInfo.filter((info) => info !== null);

            this.permissionSeleted();

            // && banderaAgente
            //     if (
            //         !!this.model.name && !!this.model.userName
            //         && !!this.model.email.value && this.model.email.valid
            //
            //         && !!this.model.profile && this.hasPermissionSelected
            //         && !!this.model.groups.length
            //         && (
            //             ((this.action == 'update' || this.action == 'edit' || this.action == 'editar') && !this.model.password) ||
            //             (!!this.model.password && this.model.password.length >= 6 &&
            //                 this.model.password === this.model.passwordConfirm)
            //         )
            //         && (!!this.model.extraInfo.key === !!this.model.extraInfo.value)
            //         && (!this.extraInfo.length || (this.extraInfo.length && this.extraInfo.findIndex((info) => info.error) < 0))
            //     ) {
            user.name = this.model.name;
            user.username = this.model.userName.trim();
            user.email = this.model.email.value ? this.model.email.value.trim() : "";
            user.numTel = this.model.numTel ? String(this.model.numTel) : "";
            user.extra1 = this.model.extra1;
            user.extra2 = this.model.extra2;
            
            if (this.model.user_dimme == null && this.model.profile != 1) {
                this.notifications.bigBox({
                    title: 'No se puede guardar',
                    content: 'Seleccione el tipo de usuario',
                    color: "#C46A69",
                    icon: "fa fa-warning shake animated",
                    timeout: 6000
                });
                return;
            }
            user.user_dimme = this.model.user_dimme;

            if (this.extraConfiguracion != null) {
                // user.extraConfiguration.ExtraConfiguration.iam.push(parseInt(this.extraConfiguracion));
                // user.extraConfiguration.push({
                //     iam: [parseInt(this.extraConfiguracion)]
                // });
                user.extraConfiguration.iam = [parseInt(this.extraConfiguracion)];
                user.extraConfiguration.att = this.FormValidacion.controls.att.value;
            } else {
                // user.extraConfiguration.ExtraConfiguration.iam = [];
                // user.extraConfiguration.push({
                //     iam: []});
                user.extraConfiguration.iam = [];
                user.extraConfiguration.att = this.FormValidacion.controls.att.value;
            }
            if (this.FormValidacion.controls.Tipo.value != 3) {
                delete (user.extraConfiguration.att);
            }
            if (typeof user.extraConfiguration.att === "string" && user.extraConfiguration.att === "Todos") {
                user.extraConfiguration.att = 0;
            }

            user.extraConfiguration.dum.ne = this.model.extraConfiguration.dum.ne;
            if (this.model.profile == 34 || this.model.profile == 64 || this.model.profile == 63) {
                user.extraConfiguration.nvm = this.model.extraConfiguration.nvm;
            }
            // obtener el permiso e2e
            if (this.extraConfiguracion == 5) {
                if (this.model.extraConfiguration.pagos == true) {

                    for (let i = 0; i < this.listOfQuioscos.length; i++) {
                        if (this.model.extraConfiguration.quiosco == this.listOfQuioscos[i].descripcion) {
                            this.model.extraConfiguration.idquiosco = this.listOfQuioscos[i].entidad_externa;
                            break;
                        }
                    }
                }
                user.extraConfiguration.e2e = this.model.extraConfiguration.e2e;
                user.extraConfiguration.bulk = this.model.extraConfiguration.bulk;
                user.extraConfiguration.priorizar = this.model.extraConfiguration.priorizar;
                user.extraConfiguration.pagos = this.model.extraConfiguration.pagos;
                user.extraConfiguration.quiosco = this.model.extraConfiguration.quiosco;
                user.extraConfiguration.idquiosco = this.model.extraConfiguration.idquiosco
                user.extraConfiguration.validarEquipo = this.model.extraConfiguration.validarEquipo;
                user.extraConfiguration.mdm = this.model.extraConfiguration.mdm;
                user.extraConfiguration.metrospre = this.model.extraConfiguration.metrospre;
                user.extraConfiguration.device = this.model.extraConfiguration.device;
                user.extraConfiguration.externa = this.model.extraConfiguration.externa;
                user.extraConfiguration.cuadlog = this.model.extraConfiguration.cuadlog;
                user.extraConfiguration.autoasgeoale = this.model.extraConfiguration.autoasgeoale;
                user.extraConfiguration.vtw = this.model.extraConfiguration.vtw;
                user.extraConfiguration.agendex = this.model.extraConfiguration.agendex;
                user.extraConfiguration.tmm = this.model.extraConfiguration.tmm;
                user.extraConfiguration.ntm = this.model.extraConfiguration.ntm;
                user.extraConfiguration.dashProd = this.model.extraConfiguration.dashProd;
                user.extraConfiguration.editarPerfil = this.model.extraConfiguration.editarPerfil;

            }
            else {
                user.extraConfiguration.validarEquipo = this.model.extraConfiguration.validarEquipo;
                user.extraConfiguration.mdm = this.model.extraConfiguration.mdm;
                user.extraConfiguration.metrospre = this.model.extraConfiguration.metrospre;
                user.extraConfiguration.device = this.model.extraConfiguration.device;
                user.extraConfiguration.externa = this.model.extraConfiguration.externa;
                user.extraConfiguration.cuadlog = this.model.extraConfiguration.cuadlog;
                user.extraConfiguration.autoasgeoale = this.model.extraConfiguration.autoasgeoale;
                user.extraConfiguration.vtw = this.model.extraConfiguration.vtw;
                user.extraConfiguration.agendex = this.model.extraConfiguration.agendex;
                user.extraConfiguration.tmm = this.model.extraConfiguration.tmm;
                user.extraConfiguration.ntm = this.model.extraConfiguration.ntm;
                user.extraConfiguration.dashProd = this.model.extraConfiguration.dashProd;
                user.extraConfiguration.priorizar = this.model.extraConfiguration.priorizar;
                user.extraConfiguration.editarPerfil = this.model.extraConfiguration.editarPerfil;
            }

            user.extra4 = this.model.extra4;
            //areglar dato extra3
            user.extra5 = this.model.extra5;
            // user.idWorkShift = this.idWorkShift;
            user.password = this.model.password;
            user.imageProfile = new ImageProfile();
            if (this.imageProfile != null) {
                user.imageProfile.imageName = this.imageProfile.imageName;
                user.imageProfile.contentType = this.imageProfile.contentType;
                user.imageProfile.encodedImageContent = this.imageProfile.encodedImageContent;
                user.imageProfile.encodedImageContentSmall = this.imageProfile.encodedImageContentSmall;
            }
            // user.idUsersAssigned = this.usersHerarchyList;
            user.userGeofenceViewList = this.usersGeofenceList;
            user.userGeofenceAlertViewList = this.usersGeofenceAlertList;
            user.extraConfiguration.tmad = this.model.extraConfiguration.tmad;

            user.profileId = +this.model.profile;

            if ((this.action == 'update' || this.action == 'edit' || this.action == 'editar' || this.action == 'add' || this.action == 'agregar') && this.model.password)
                user.password = this.shaService.encrypt(this.model.password + '{' + user.username + '}', 1000, 'SHA-256', 'HEX');
            else
                user.password = '';
            user.status = this.model.status;
            //Se agrega al arreglo de extraInfo la información extra guardada
            this.extraInfo.forEach((info) => {
                let extraInfo: ExtraInfo = new ExtraInfo;
                extraInfo.userExtraInfoId = info.userExtraInfoId;
                extraInfo.key = info.key;
                extraInfo.value = info.value;
                user.extraList.push(extraInfo);
            });
     
            if (this.extraConfiguracion != this.typeTicket.OPERACIONES) {
                user.extraConfiguration.dashProd = false;
            }
            
            let userView: UserView = new UserView;
            console.log(forma);


            if (forma.valid) {
                switch (this.action) {
                    case 'add':
                    case 'agregar':
                        //DESHABILITAR SIEMPRE ESTE PERMISO
                        user.permissionsList = user.permissionsList.filter((permissionId) => permissionId !== 132);
                        if (forma.value.statusUser == false) {
                            forma.value.statusUser = 'INACTIVO';
                        }
                        if (forma.value.statusUser == true) {
                            forma.value.statusUser = 'ACTIVO';
                        }
                        this.Botonbloqueado = true; 6
                        user.status = forma.value.statusUser;
                        userView.userAppView = user;
                        userView.idWorkShift = +this.idWorkShift;
                        // this.service.guardar(user).subscribe(() => {

                        // if (this.bandExpRegCuadrilla == false) {
                        this.service.guardar(userView).subscribe((response: any) => {
                            if(response.message && response.message.length > 0){
                                this.Botonbloqueado = false;
                                this.notifications.bigBox({
                                    title: this.error1,
                                    content: response.message,
                                    color: "#C46A69",
                                    icon: "fa fa-warning shake animated",
                                    timeout: 6000
                                });
                                return;
                            }
                            this.notifications.bigBox({
                                title: this.confirm1,
                                content: this.confirmContent1 + ": <b>" + user.name + "</b> - <i>" + user.username + "</i>",
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 8000
                            });
                            this.Cancel();
                        }, (error) => {
                            let errorMsg: string = this.error1;
                            let errorGW = "No fue posible insertar el usuario, ya se encuentra uno con el mismo username o extra1";
                            if (!!error.code) {
                                errorMsg = '<i>Error: ' + error.code + '</i><br>';
                                if (!!error.errorList.length) errorMsg += error.errorList[0];
                                else errorMsg += error.message;
                            } else errorMsg = this.errorContent1;
                            if (error["GW-code"] == "DAOUSER101" || error["GW-message"] == "No fue posible insertar el usuario, ya se encuentra uno con el mismo username o extra1"
                                || error["GW-errorList"][0] == "createUserApp - Exception: No fue posible insertar el usuario, ya se encuentra uno con el mismo username o extra1") {
                                this.notifications.bigBox({
                                    title: this.error1,
                                    content: errorGW,
                                    color: "#C46A69",
                                    icon: "fa fa-warning shake animated",
                                    timeout: 6000
                                });
                            } else {
                                this.notifications.bigBox({

                                    title: this.error1,
                                    content: errorMsg,
                                    color: "#C46A69",
                                    icon: "fa fa-warning shake animated",
                                    timeout: 6000
                                });
                            }
                            this.Botonbloqueado = false;
                        });
                        // }
                        break;
                    case 'update':
                    case 'edit':
                    case 'editar':
                        if(!this.havePremisionEditPermsisions){
                            user.permissionsList = user.permissionsList.filter((permissionId) => permissionId !== 132);
                        }
                        user.idUserApp = this.id;
                        user.username = forma.value.username;//this.model.realUserName;
                        if (this.model.status == false) {
                            forma.value.statusUser = 'INACTIVO';
                        }
                        if (this.model.status == true) {
                            forma.value.statusUser = 'ACTIVO';
                        }
                        // if(user.extra3 == "" || user.extra3 == " " || isNullOrUndefined(user.extra3)){
                        //     user.extra3 = null;
                        // }


                        user.status = forma.value.statusUser;
                        this.model.userName = user.username;
                        userView.userAppView = user;
                        userView.idWorkShift = +this.idWorkShift;
                        userView.userAppView.numTel = this.model.numTel ? String(this.model.numTel) : "";
                        //this.usersTable.reload();
                        // this.service.update(user).subscribe(() => {
                        // if (this.bandExpRegCuadrilla == false) {
                        this.Botonbloqueado = true;

                        this.service.modificar_usuario(userView).subscribe((response: any) => {
                            if(response.message && response.message.length > 0){
                                this.Botonbloqueado = false;
                                this.notifications.bigBox({
                                    title: this.error1,
                                    content: response.message,
                                    color: "#C46A69",
                                    icon: "fa fa-warning shake animated",
                                    timeout: 6000
                                });
                                return;
                            }
                            this.notifications.bigBox({
                                title: this.confirm1,
                                content: this.confirmContent2 + ": <b>" + user.name + "</b> - <i>" + user.username + "</i>",
                                color: "#739E73",
                                icon: "fa fa-check",
                                timeout: 8000
                            });
                            this.Cancel();
                            localStorage.removeItem("userData");
                            this.service.get(this.authorization.token.userId).subscribe(success => {
                            });
                            //    enrutar a la  utlima vista
                        }, error => {
                            let errorMsg: string = this.error2;
                            if (!!error.code) {
                                errorMsg = '<i>Error: ' + error.code + '</i><br>';
                                if (!!error.errorList.length) errorMsg += error.errorList[0];
                                else errorMsg += error.message;
                            } else errorMsg = this.errorContent2;

                            this.notifications.bigBox({
                                title: this.error2,
                                content: errorMsg,
                                color: "#C46A69",
                                icon: "fa fa-warning shake animated",
                                timeout: 6000
                            });
                            this.Botonbloqueado = false;
                        });
                        // }

                        break;
                    default:
                        break;
                }
            }
            // }
        } 
        else {
            console.log("aquiiNvalid");
            let mensajesErrores: string = '';
            this.Errors.forEach((error) => {

                if (error.errorName === 'required') {
                    if (error.nombreReal == 'quiosco') {
                        error.nombreReal = 'Punto de venta'
                    }
                    mensajesErrores += error.nombreReal + ': Campo requerido <br>';
                }
                if (error.errorName === 'min') {
                    mensajesErrores += error.nombreReal + ': Requiere un valor minimo';
                    const reactiveError: { min: number, actual: number } = this.FormValidacion.get('maxTimeOnTicket').getError('min');
                    if (reactiveError && reactiveError.min) {
                        mensajesErrores += ' de ' + reactiveError.min;
                    }

                    mensajesErrores += '<br>';
                }
                if (error.errorName === 'minlength') { mensajesErrores += error.nombreReal + ': Debe contener 8 caracteres. <br>'; }
                // if (error.errorName === 'pattern' && error.controlName == 'password') { mensajesErrores += error.nombreReal + ': La contraseña no tiene formato valido. <br>'; }
                if (error.errorName === 'pattern' && error.controlName != 'numTel') { mensajesErrores += error.nombreReal + ': Formato inválido. <br>'; }
                if (error.errorName === 'pattern' && error.controlName == 'Cuadrilla') { mensajesErrores += error.nombreReal + ': Formato inválido, el formato tiene que ser letra-número ejem.(i-230).<br>'; }
                if (error.errorName === 'pattern' && error.controlName == 'noVendedor') { mensajesErrores += error.nombreReal + ': Formato inválido, el formato tiene que ser solo números. <br>'; }
                if (error.errorName === 'pattern' && error.controlName == 'username') { mensajesErrores += error.nombreReal + ': Formato inválido, no tiene que tener espacios o caracteres especiales.<br>'; }
                if (error.errorName === 'pattern' && error.controlName == 'numTel') { mensajesErrores += error.nombreReal + ': Número inválido, debe tener 10 dígitos.<br>'; }
                if (error.errorName === 'email' && error.controlName == 'email') { mensajesErrores += error.nombreReal + ':  Formato inválido, Ingresa un correo válido.<br>'; }
            });
            if (this.model && this.model.userName !== undefined) {
                if (/\s/.test(this.model.userName)) {
                    mensajesErrores += 'El nombre de usuario no puede llevar espacios <br>';
                }
            } else {
                mensajesErrores += 'El nombre de usuario no está definido <br>';
            }
            if (this.model.profile == 0) {
                mensajesErrores += 'Debes agregar un perfil de usuario <br>';
            }
            if (this.idWorkShift == 0) {
                mensajesErrores += 'Debes agregar un turno laboral <br>';
            }
            if (this.model.groups.length == 0) {
                mensajesErrores += 'Debes agregar un grupo por lo menos <br>';
            }

            console.log('Validandi', this.model.extraConfiguration)
            if (this.model.extraConfiguration.pagos == true) {
                if (this.model.extraConfiguration.quiosco == "" || this.model.extraConfiguration.quiosco == null) {
                    mensajesErrores += 'Debes elegir un punto de venta <br>';
                }
            }
            if (!hasMoreGroups) {

                let wholeGroups = [];
                groupsSelected.forEach((group) => {
                    wholeGroups.push(this.capitalize(group.nameSucursalPadre.toLowerCase()));
                });
                //filtrar para que que no haya duplicados
                if (wholeGroups.length != 0) {
                    var hash = {};
                    wholeGroups = wholeGroups.filter(function (current) {
                        var exists = !hash[current];
                        hash[current] = true;
                        return exists;
                    });
                }
                let mensaje = ""
                wholeGroups.forEach((nameGroup, index) => {
                    if (index < 20 && (wholeGroups.length - 1) != index) {
                        mensaje += nameGroup + ", ";
                    } else if (index == 20 && (wholeGroups.length - 1) != index) {
                        mensaje += " etc..."
                    } else if (index < 20 && (wholeGroups.length - 1) == index) {
                        mensaje += nameGroup + ".";
                    }
                });
                mensajesErrores += `Selecciona sucursales de 1 solo grupo padre, tienes sucursales de: <br>${mensaje}<br>`;
            }
            if (validarCheckPresionado.length == 0) {
                mensajesErrores += 'Debes agregar un permiso por lo menos <br>';
            }
            // if ( this.model.password != null && this.model.passwordConfirm != null && this.model.password
            // != this.model.passwordConfirm ){mensajesErrores += 'Contraseña y confirmar contraseña deben coincidir<br>'; this.passwordsIguales = true;}else{
            // this.passwordsIguales = false;
            // }
            if (this.passwordsIguales == true) {
                mensajesErrores += 'Contraseña y confirmar contraseña deben coincidir.<br>';
            }
            // const hasAutoasgeoale = this.model.extraConfiguration.autoasgeoale;
            // if (!hasAutoasgeoale && this.currentSelectItems.length > 4) {
            //     mensajesErrores += 'Solo puedes tener 4 Geocercas como máximo asignadas';
            // }
            // if (hasAutoasgeoale && this.currentSelectItems.length > 1) {
            //     mensajesErrores += 'Solo puedes tener 1 Geocerca como máximo asignada';
            // }
            if (mensajesErrores != '') {
                this.createNotification('warning', 'Error en el formulario', mensajesErrores);
            }
        }
    }


    capitalize(val) {
        return val.toLowerCase()
            .trim()
            .split(' ')
            .map(v => v[0].toUpperCase() + v.substr(1))
            .join(' ');
    }
    clickQuiosco(){
        if(this.model.extraConfiguration.pagos==false){
            this.model.extraConfiguration.quiosco='';
            this.model.extraConfiguration.idquiosco='';
        }
        console.log('Agregar',this.action,this.model.extra1)
        if(this.action=="add"){
            if(this.model.extra1){
                this.userService.ObtenerQuiosco(this.model.extra1).subscribe((resp)=>{
                    
                      
                      if(resp.error==true){
                        this.model.extraConfiguration.pagos=false;
                        this.notifications.bigBox({
                            title: 'Error al cargar puntos de venta',
                            content: 'La sucursal no tiene puntos de venta',
                            color: "#C46A69",
                            icon: "fa fa-warning shake animated",
                            timeout: 6000
                        });
                      }else{
                        this.listOfQuioscos=resp.entidad_externa;
                      }
                      },(error)=>{
                       console.log('error',error);
                  });
            }else{
                this.model.extraConfiguration.pagos=false;
                this.notifications.bigBox({
                    title: 'Error al cargar puntos de venta',
                    content: 'Llena el campo sucursal',
                    color: "#C46A69",
                    icon: "fa fa-warning shake animated",
                    timeout: 6000
                });
                this.model.extraConfiguration.pagos=false;
            }
            
        }
    }

    profileImage($event): void {
        this.imageProfile = new ImageProfile();
        let file = $event.target.files[0]; //carga de archivo
        if (!isNullOrUndefined(file)) {
            let fileName = file.name;
            this.imageProfile.contentType = file.type;
            let myReader: FileReader = new FileReader();
            myReader.onloadend = () => {
                let image: string = <string>myReader.result;
                this.imageProfile.imageName = fileName;
                this.imageProfile.encodedImageContent = image.split(',')[1];
                this.imageProfile.encodedImageContentSmall = this.imageProfile.encodedImageContent;
            };
            myReader.readAsDataURL(file);
        }
    }
    

    imageResult(event: any) {
        this.imageProfile.contentType = event.contentType;
        this.imageProfile.encodedImageContentSmall = event.base64;
        this.toggleImageCrop();
    }

    public getData(fileType: string, base64: string): SafeHtml {
        let data: string = 'data:' + fileType + ';base64,' + base64;
        return this.domSn.bypassSecurityTrustResourceUrl(data);
    }

    private changeTab(index: number): void {
        if ((this.model.profile == 134 || this.model.profile === 27 || this.model.profile === 94 || this.model.profile === 30 || this.model.profile === 63 || this.model.profile === 64 || this.model.profile == 34 || this.model.profile == 88 || this.model.profile == 92 || this.model.profile == 103)) {
            if (index === 0) {
                $('#contPrincipalUser').scrollTop(0);
            }
            if (index === 1) {
                $('#contPrincipalUser').scrollTop(711);
            }
            if (index === 2) {
                $('#contPrincipalUser').scrollTop(1022);
            }
            if (index === 3) {
                $('#contPrincipalUser').scrollTop(1299);
            }

        } else {
            //verifica si tiene lista de usuarios
            if (this.duallistUserList.length != 0) {
                this.tamDualis = 225;
            } else {
                this.tamDualis = 0;
            }

            if (index === 0) {
                $('#contPrincipalUser').scrollTop(0);
            }
            if (index === 1) {
                $('#contPrincipalUser').scrollTop(711);
            }
            if (index === 2) {
                $('#contPrincipalUser').scrollTop(1022);
            }
            if (index === 3) {
                $('#contPrincipalUser').scrollTop(1202 + this.tamDualis);
            }
            if (index === 4) {
                $('#contPrincipalUser').scrollTop(1482 + this.tamDualis);
            }
        }
    }
    groupDataByRegions(data: Principals[]): Principals[] {
        let principalArray: Principals[] = [];

        data.forEach((principal: Principals) => {
            let zonaArray: Zonas[] = [];

            principal.children.forEach((groups: GroupsChildren) => {
                // Obtener la región del grupo directamente del API
                // Si el grupo tiene región, usarla; si no, verificar los children
                let regionName: string | null | undefined = groups.region;

                // Si el grupo no tiene región, verificar si todos los children tienen la misma
                if (!regionName && groups.children && groups.children.length > 0) {
                    const firstChildRegion = groups.children[0].region;
                    const allSameRegion = groups.children.every(child => child.region === firstChildRegion);
                    if (allSameRegion && firstChildRegion) {
                        regionName = firstChildRegion;
                    }
                }

                // Si no hay región definida, usar "SIN REGIÓN"
                const zonaKey = regionName || "SIN REGIÓN";

                // Buscar o crear la zona
                let existingZona = zonaArray.find((element: Zonas) =>
                    element.content.toUpperCase().trim() === zonaKey.toUpperCase().trim()
                );

                if (!existingZona) {
                    const newZona: Zonas = {
                        active: false,
                        children: [],
                        content: zonaKey,
                        expanded: true,
                        extra3: false,
                        id: 0,
                        module: null
                    };
                    zonaArray.push(newZona);
                    existingZona = newZona;
                }

                // Agregar el grupo a la zona
                const existingGroup = existingZona.children.find((group) => group.content == groups.content);

                if (existingGroup) {
                    // Agregar los children al grupo existente
                    groups.children.forEach((child: Childrens) => {
                        existingGroup.children.push(child);
                    });
                } else {
                    existingZona.children.push({ ...groups });
                }
            });

            // Ordenar las zonas alfabéticamente, pero colocar "SIN REGIÓN" al final
            zonaArray.sort((a, b) => {
                if (a.content === "SIN REGIÓN") {
                    return 1;
                } else if (b.content === "SIN REGIÓN") {
                    return -1;
                } else {
                    return a.content.localeCompare(b.content);
                }
            });

            let data: Principals = {
                active: principal.active,
                children: zonaArray,
                content: principal.content,
                expanded: principal.expanded,
                extra3: principal.extra3,
                id: principal.id,
                module: principal.module
            };

            principalArray.push(data);
        });

        // Ordenar los Principals alfabéticamente
        principalArray.sort((a, b) => a.content.localeCompare(b.content));

        // Ordenar los Groups alfabéticamente dentro de cada Zona
        principalArray.forEach((principal) => {
            principal.children.forEach((zona) => {
                zona.children.sort((a, b) => a.content.localeCompare(b.content));

                // Ordenar los Childrens alfabéticamente dentro de cada Group
                zona.children.forEach((group) => {
                    group.children.sort((a, b) => a.content.localeCompare(b.content));
                });
            });
        });
        this.logZonasAndChildren(principalArray);

        return principalArray;
    }

    logZonasAndChildren(data: Principals[]): void {
        let cadena = "";
        data.forEach((principal) => {
            principal.children.forEach((zona) => {
                console.log(`----Zona: ${zona.content} -----`);
                zona.children.forEach((group) => {
                    group.children.forEach((child) => {
                        cadena = cadena + (`${child.content}\n`);
                    });
                });
                console.log(cadena);
                cadena = "";
            });
        });
        
    }

    validateAllActive(data: Principals[]): Principals[] {
        return data.map((principal: Principals) => {
            return {
                ...principal,
                children: principal.children.map((zona: Zonas) => {
                    const allGroupsActive = zona.children.every((group: GroupsChildren) => group.active);
                    return {
                        ...zona,
                        active: allGroupsActive,
                        children: zona.children.map((group: GroupsChildren) => {
                            const allChildrenActive = group.children.every((child: Childrens) => child.active);
                            return {
                                ...group,
                                active: allChildrenActive,
                                children: group.children.map((child: Childrens) => ({
                                    ...child,
                                })),
                            };
                        }),
                    };
                }),
            };
        });
    }

    cerrarModal() {
        this.bsModalRef.hide();
    }

    clickSwitch(){
        // this.model.extraConfiguration.e2e = !this.model.extraConfiguration.e2e;
        // console.log(this.model.extraConfiguration.e2e)
    }

    get password() {
        return this.FormValidacion.get('password');
    }
    get password_confirm() {
        return this.FormValidacion.get('passwordConfirm');
    }

    togglePassword(ojo: number){
        switch (ojo) {
            case 1:
                if(this.ojo1 == 'text'){
                    this.ojo1 = 'password';
                }else{
                    this.ojo1 = 'text';
                }
                this.showPassword1 = !this.showPassword1;
                break;
            case 2:
                if(this.ojo2 == 'text'){
                    this.ojo2 = 'password';
                }else{
                    this.ojo2 = 'text';
                }
                this.showPassword2 = !this.showPassword2;
                break;
            default:
                break;
        }
    }

    getUserInfo(){
        this.btnUserinfo = true;
        this.deviceService.getUserInfo(this.id.toString()).subscribe(res => {
            this.infoUserError = false;
            this.showbtnDelete = true;
            console.log(res)
            this.infoUSer = res;
            this.btnUserinfo = false;
            this.infoUSer.enable = this.infoUSer.enable ? 'Activo' : 'Inactivo'
        },(err) =>{
            console.log(err)
            this.infoUserError = true;
            this.btnUserinfo = false;
            console.log(this.infoUSer)
        })
    }

    deleteUserInfo(){
        this.btnUserinfo = true;
        this.deviceService.DeleteUserInfo(this.infoUSer.idUserDevice).subscribe(res => {
            this.infoUserError = false;
            console.log(res)
            this.infoUSer.username = null
            this.createNotification('success', 'Información eliminada correctamente.');
            this.btnUserinfo = false;
            this.showbtnDelete = false;
        },(err) =>{
            console.log(err)
            this.infoUSer.username = null
            this.infoUserError = true;
            this.btnUserinfo = false;
            this.createNotification('error', 'Error al eliminar uuid.');
            console.log(this.infoUSer)
        })
    }
    defaultTimeDead():void{
        if(!this.model.extraConfiguration.tmm)
        {
            this.model.extraConfiguration.tmm = 60;
            this.FormValidacion.controls['tmm'].patchValue(60);
        }    
    }

    onInput(event: Event, max: number, opc: string): void {
        const input = event.target as HTMLInputElement;
        const maxLength = max;
        if (opc == 'ne') {
            this.userDimmeValidado = false;
            if (input.value.length > maxLength) {
                input.value = input.value.slice(0, maxLength);
                this.model.extraConfiguration.dum.ne = +input.value;
            }
        }
        else if (opc == 'nvm') {
            if (input.value.length > maxLength) {
                input.value = input.value.slice(0, maxLength);
                this.model.extraConfiguration.nvm = +input.value;
            }
        }
    }

    findEmployee(): void {
        if (!this.model.extraConfiguration.dum.ne) {
            this.createNotification('warning', 'Ingrese un número de empleado.', '');
            return;
        }
        this.validandoEmpleado = true;
        this.userService.findEmployee({
            numero_empleado: this.model.extraConfiguration.dum.ne,
        }).subscribe((res: any) => {
            this.validandoEmpleado = false;
            if (res && res.estatus && res.mensaje.toLowerCase() == 'exito') {
                this.userDimmeValidado = true;
                this.FormValidacion.controls['name'].patchValue(res.nombre_completo);
                this.model.name = res.nombre_completo;
                this.createNotification('success', res.mensaje, 'Número de empleado válido');
            } else {
                this.userDimmeValidado = false;
                this.FormValidacion.controls['name'].patchValue('');
                this.model.name = '';
                this.createNotification('warning', 'Número de empleado inválido', res.mensaje);
            }
        }, err => {
            this.validandoEmpleado = false;
            this.userDimmeValidado = false;
            this.FormValidacion.controls['name'].patchValue('');
            this.model.name = '';
            this.createNotification('warning', 'No se pudo validar el número de empleado', 'Intente nuevamente más tarde.');
        });
    }
}

class chatContainerCtrl {
    element: HTMLElement;
    scrolledByUser: boolean = false;
    previousScrollTop: number;
}
